export default {
  // Common
  common: {
    save: 'Salva',
    cancel: 'Annulla',
    delete: 'Elimina',
    edit: 'Modifica',
    create: 'Crea',
    search: 'Cerca',
    filter: 'Filtra',
    loading: 'Caricamento...',
    noData: 'Nessun dato',
    confirm: 'Conferma',
    close: 'Chiudi',
    yes: 'Sì',
    no: 'No',
    actions: 'Azioni',
    status: 'Stato',
    date: 'Data',
    name: 'Nome',
    description: 'Descrizione',
    type: 'Tipo',
    download: 'Scarica',
    upload: 'Carica',
    copy: 'Copia',
    copied: 'Copiato!',
    error: 'Errore',
    success: 'Successo',
    warning: 'Attenzione',
    info: 'Informazione',
    all: 'Tutto',
    allTypes: 'Tutti i tipi',
    allStatuses: 'Tutti gli stati',
    none: 'Nessuno',
    active: 'Attivo',
    inactive: 'Inattivo',
    enabled: 'Abilitato',
    disabled: 'Disabilitato',
    refresh: 'Aggiorna',
    back: 'Indietro',
    next: 'Avanti',
    previous: 'Precedente',
    finish: 'Fine',
    submit: 'Invia',
    confirmDeleteItem: 'Vuoi eliminare questo elemento?',
    validateForReport: 'Valida per Report',
    reset: 'Reimposta',
    view: 'Visualizza',
    details: 'Dettagli',
    more: 'Altro',
    less: 'Meno',
    today: 'Oggi',
    yesterday: 'Ieri',
    thisWeek: 'Questa settimana',
    thisMonth: 'Questo mese',
    optional: 'Opzionale',
    required: 'Richiesto',
    note: 'Nota:',
    and: 'e',
    andThe: 'e i',
    or: 'o',
    sending: 'Invio...',
    redirecting: 'Reindirizzamento...',
    copyright: '© 2026 SYLink. Tutti i diritti riservati.',
    add: 'Aggiungi',
    execute: 'Esegui',
    launch: 'Avvia',
    pause: 'Pausa',
    generating: 'Generazione...',
    copiedToClipboard: 'Copiato negli appunti',
    emailRequired: 'Email richiesta',
    regenerate: 'Rigenera',
    deselect: 'Deseleziona',
    goBack: 'Torna alla dashboard',
    unknown: 'Sconosciuto',
    notDetected: 'Non rilevato',
    notDetectedFeminine: 'Non rilevata',
    notAvailable: 'Non disponibile',
    requiredFields: 'Campi obbligatori',
    useAssistant: 'Usa l\'assistente IA per iniziare'
  },

  // Navigation
  nav: {
    dashboard: 'Dashboard',
    scans: 'Scansioni',
    workspaces: 'Workspaces',
    vulnerabilities: 'Vulnerabilità',
    reports: 'Report',
    settings: 'Impostazioni',
    account: 'Il mio account',
    logout: 'Esci',
    help: 'Aiuto',
    admin: 'Amministrazione',
    tools: 'Strumenti',
    compliance: 'Conformità',
    notifications: 'Notifiche',
    credentials: 'Credenziali',
    ad: 'Active Directory',
    sessions: 'Sessioni',
    agents: 'Agenti'
  },

  // Auth
  auth: {
    login: 'Accedi',
    logout: 'Esci',
    register: 'Registrati',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Conferma password',
    forgotPassword: 'Password dimenticata?',
    magicLink: 'Magic Link',
    resetPassword: 'Reimposta password',
    resetPasswordNeedsLink: 'Per reimpostare la tua password, utilizza il link inviato via email. Puoi richiedere un nuovo link dalla pagina di accesso.',
    rememberMe: 'Ricordami',
    loginSuccess: 'Accesso riuscito',
    loginError: 'Credenziali non valide',
    logoutSuccess: 'Disconnessione riuscita',
    sessionExpired: 'Sessione scaduta',
    twoFactor: 'Autenticazione a due fattori',
    enterCode: 'Inserisci il codice',
    verifyCode: 'Verifica codice',
    invalidCode: 'Codice non valido',
    // Register page
    createAccount: 'Crea un account',
    fillFormBelowEmail: 'Compila il modulo qui sotto per creare il tuo account aziendale.',
    companyName: 'Nome azienda',
    companyPlaceholder: 'La tua azienda',
    firstName: 'Nome',
    firstNamePlaceholder: 'Il tuo nome',
    lastName: 'Cognome',
    lastNamePlaceholder: 'Il tuo cognome',
    professionalEmail: 'Email professionale',
    professionalEmailPlaceholder: 'tu@tuaazienda.it',
    professionalPhone: 'Telefono professionale',
    phonePlaceholder: '+39 123 456 7890',
    passwordEmailNote: 'Imposterai la password dopo la verifica dell\'email.',
    acceptTermsPrefix: 'Accetto i',
    createMyAccount: 'Crea il mio account',
    registering: 'Creazione in corso...',
    alreadyHaveAccount: 'Hai già un account?',
    loginButton: 'Accedi',
    byRegistering: 'Creando un account, accetti i nostri termini di utilizzo e la politica sulla privacy.',
    registrationSuccess: 'Registrazione riuscita!',
    registrationEmailSent: 'Un\'email di conferma è stata inviata a',
    clickLinkToSetPassword: 'Clicca sul link per impostare la password e attivare il tuo account.',
    checkSpam: 'Controlla la cartella spam se non vedi l\'email.',
    backToLogin: 'Torna al login',
    // Email verification
    verifying: 'Verifica in corso...',
    verifyingDescription: 'Attendere mentre verifichiamo il tuo indirizzo email.',
    emailVerified: 'Email verificata!',
    accountActive: 'Il tuo account è ora attivo.',
    welcome: 'Benvenuto su SYLink!',
    choosePlan: 'Scegli il mio piano',
    redirectingToPlan: 'Reindirizzamento ai prezzi tra {seconds} secondi...',
    orLoginDirectly: 'Oppure {loginLink} direttamente',
    verificationFailed: 'Verifica fallita',
    needNewVerificationLink: 'Hai bisogno di un nuovo link di verifica?',
    yourEmail: 'La tua email',
    emailSent: 'Email inviata!',
    resendLink: 'Reinvia link',
    invalidLink: 'Link non valido',
    requestNewVerificationLink: 'Richiedi un nuovo link di verifica',
    sendLink: 'Invia link',
    // Login page
    welcomeBack: 'Bentornato!',
    enterCredentials: 'Inserisci le tue credenziali per accedere al tuo spazio.',
    loggingIn: 'Accesso in corso...',
    noAccount: 'Non hai un account?',
    createAccountLink: 'Crea un account',
    createFreeAccount: 'Crea un account gratuito',
    // Password reset
    resetPasswordTitle: 'Reimposta password',
    resetPasswordDesc: 'Inserisci la tua email per ricevere un link di reimpostazione.',
    sendResetLink: 'Invia link',
    sending: 'Invio in corso...',
    resetLinkSent: 'Link inviato!',
    resetLinkSentDesc: 'Controlla la tua casella di posta per reimpostare la password.',
    newPassword: 'Nuova password',
    confirmNewPassword: 'Conferma password',
    setNewPassword: 'Imposta password',
    passwordUpdated: 'Password aggiornata!',
    passwordUpdatedDesc: 'Ora puoi accedere con la tua nuova password.',
    // Missing auth keys
    accountBlocked: 'Account bloccato',
    autoRedirecting: 'Reindirizzamento automatico...',
    charactersCount: '{count} caratteri',
    checkYourInbox: 'Controlla la tua casella di posta',
    chooseSecurePassword: 'Scegli una password sicura per il tuo account',
    classic: 'Classico',
    confirmPasswordPlaceholder: 'Conferma la tua password',
    connectionError: 'Errore di connessione. Verifica la tua connessione internet e riprova.',
    createAccountWithProfessionalEmail: 'Crea un account con email professionale',
    createDemoAccount: 'Crea il tuo account demo',
    createNewAccountMessage: 'Per continuare, crea un nuovo account con la tua email professionale:',
    demoAccountReady: 'Il tuo account demo è pronto!',
    emailAddressLabel: 'Indirizzo email',
    emailNotVerified: 'Email non verificata',
    emailNotVerifiedMessage: 'Verifica la tua casella di posta e clicca sul link di conferma.',
    emailOrUsername: 'Indirizzo email',
    emailPlaceholder: 'tua-email@esempio.it',
    emailSentTitle: 'Email inviata',
    enterEmailForResetLink: 'Inserisci il tuo indirizzo email e ti invieremo un link per reimpostare la password.',
    fillDemoInfo: 'Inserisci le tue informazioni per accedere al tuo spazio demo.',
    forgotPasswordModalTitle: 'Password dimenticata?',
    genericError: 'Si è verificato un errore. Riprova.',
    ifAccountExistsPrefix: 'Se esiste un account con l\'indirizzo',
    ifAccountExistsSuffix: ', riceverai un link per reimpostare la tua password.',
    linkExpiresCheckSpam: 'Il link scadrà tra 24 ore. Ricorda di controllare la cartella spam.',
    loginSubtitle: 'Accedi per entrare nel tuo spazio di sicurezza.',
    lowercase: '1 minuscolo',
    magicLinkExpired: 'Questo link è scaduto. Richiedine uno nuovo.',
    magicLinkFooter: 'Magic Link - Accesso sicuro senza password',
    magicLinkInvalid: 'Questo link non è più valido.',
    magicLinkLoginFailed: 'Accesso non riuscito. Riprova.',
    magicLinkNotFound: 'Questo link non esiste o è già stato utilizzato.',
    minChars: '8 caratteri min',
    needHelp: 'Hai bisogno di aiuto? Contattaci',
    newPasswordPlaceholder: 'Inserisci la tua nuova password',
    number: '1 numero',
    orEnterManually: 'o inserisci manualmente',
    passwordChanged: 'Password modificata!',
    passwordGenerator: 'Generatore di password',
    passwordMinLength: 'Minimo 8 caratteri',
    passwordMinLengthError: 'La password deve contenere almeno 8 caratteri',
    passwordPlaceholder: 'Password',
    passwordResetSuccess: 'La tua password è stata reimpostata con successo. Verrai reindirizzato alla pagina di accesso.',
    passwordsMatch: 'Password identiche',
    personalEmailBlockedMessage: 'Questo account utilizza un indirizzo email personale che non è più accettato.',
    personalEmailsNotAccepted: 'Le email personali (Gmail, Hotmail, Yahoo, ecc.) non sono accettate.',
    phoneFormatHint: 'Il prefisso +39 è precompilato automaticamente. Formato: +39 123 456 7890',
    professionalEmailOnly: 'Sono ammessi solo indirizzi email professionali.',
    quantumResistant: 'Quantum-Resistente',
    quantumSecurityDescription: 'Massima sicurezza contro i futuri attacchi quantistici',
    redirectingToDashboard: 'Verrai reindirizzato alla tua dashboard...',
    regenerate: 'Rigenera',
    requestNewMagicLink: 'Puoi richiedere un nuovo magic link dalla pagina di accesso.',
    resendVerificationLink: 'Reinvia l\'email di verifica',
    resettingPassword: 'Reimpostazione...',
    retrying: 'Nuovo tentativo...',
    securityPolicy: 'Politica di sicurezza:',
    sendResetLinkFull: 'Invia link di reimpostazione',
    sendingInProgress: 'Invio in corso...',
    specialChar: '1 carattere speciale',
    unauthorized: 'Accesso non autorizzato',
    uppercase: '1 maiuscolo',
    verificationEmailSent: 'Email di verifica inviata!',
    verificationTimeout: 'La verifica ha impiegato troppo tempo. Riprova.',
    verifyingLink: 'Stiamo verificando il tuo link di accesso'
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    welcome: 'Benvenuto, {name}',
    overview: 'Panoramica',
    recentScans: 'Scansioni recenti',
    statistics: 'Statistiche',
    quickActions: 'Azioni rapide',
    newScan: 'Nuova scansione',
    viewAllScans: 'Vedi tutte le scansioni',
    totalScans: 'Scansioni totali',
    activeScans: 'Scansioni attive',
    completedScans: 'Scansioni completate',
    failedScans: 'Scansioni fallite',
    vulnerabilitiesFound: 'Vulnerabilità trovate',
    criticalVulns: 'Vulnerabilità critiche',
    highVulns: 'Vulnerabilità alte',
    mediumVulns: 'Vulnerabilità medie',
    lowVulns: 'Vulnerabilità basse',
    systemHealth: 'Stato del sistema',
    toolsStatus: 'Stato degli strumenti',
    cpuUsage: 'Utilizzo CPU',
    memoryUsage: 'Utilizzo memoria',
    diskUsage: 'Utilizzo disco',
    // Service status
    services: {
      backendApi: 'API Backend',
      frontend: 'Frontend',
      postgresql: 'PostgreSQL',
      aiModels: 'Modelli IA'
    },
    serviceStatus: {
      online: 'Online',
      offline: 'Offline',
      checking: 'Controllo',
      degraded: 'Degradato'
    },
    attackTools: {
      reconnaissance: 'Ricognizione',
      exploitation: 'Exploitation',
      bruteForce: 'Brute Force',
      postExploitation: 'Post-Exploitation',
      privilegeEscalation: 'Escalation privilegi'
    },
    targets: {
      webApps: 'Applicazioni Web',
      servers: 'Server',
      databases: 'Database',
      network: 'Rete',
      networkDevices: 'Router, switch',
      target: 'Obiettivo'
    },
    resources: {
      high: 'Alto',
      medium: 'Medio',
      normal: 'Normale',
      critical: 'Critico',
      optimal: 'Ottimale',
      active: 'Attivo',
      inUse: 'In uso',
      idle: 'In attesa',
      notDetected: 'Non rilevato',
      gpuNotAvailable: 'GPU non disponibile',
      aiDisabled: 'IA disabilitata',
      cores: 'core',
      multiCore: 'Multi-core',
      systemLoad: 'Carico sistema',
      used: 'utilizzati',
      calculating: 'Calcolo...',
      total: 'totale',
      totalCores: 'Core totali',
      totalMemory: 'RAM totale',
      computePower: 'Potenza calcolo',
      ramCapacity: 'Capacità memoria',
      aiCapacity: 'Capacità IA',
      availableTotal: 'Disponibile / Totale',
      cpuCores: 'Core CPU',
      ramInfra: 'RAM Infra.',
      gpuVram: 'VRAM GPU',
      aiReady: 'IA Pronta',
      temperatureOk: 'OK',
      servers: 'server',
      onlineCount: 'online',
      offlineCount: 'offline',
      gpuOnline: 'GPU online',
      model: 'modello'
    },
    monitoring: 'Monitoraggio e analisi della sicurezza in tempo reale',
    critical: 'crit',
    serverPerformance: 'Prestazioni server',
    realtimeMonitoring: 'Monitoraggio in tempo reale delle risorse di sistema',
    online: 'Online',
    uptime: 'Tempo di funzionamento',
    activeProcesses: 'Processi attivi',
    scansToday: 'Scansioni oggi',
    networkLoad: 'Carico rete',
    temperature: 'Temperatura',
    started: 'Avviato',
    noActiveScans: 'Nessuna scansione attiva. Avvia una nuova scansione per iniziare.',
    noRecentActivity: 'Nessuna attività recente.',
    startAssessment: 'Avvia una valutazione di sicurezza',
    exportResults: 'Esporta risultati scansioni',
    recentActivity: 'Attività recente',
    infrastructureTotal: 'Infrastruttura totale'
  },

  // Scans
  scans: {
    title: 'Scansioni',
    newScan: 'Nuova scansione',
    scanHistory: 'Cronologia scansioni',
    target: 'Obiettivo',
    targets: 'Obiettivi',
    scanType: 'Tipo di scansione',
    startScan: 'Avvia scansione',
    stopScan: 'Interrompi scansione',
    pauseScan: 'Pausa',
    resumeScan: 'Riprendi',
    deleteScan: 'Elimina scansione',
    scanDetails: 'Dettagli scansione',
    scanResults: 'Risultati scansione',
    progress: 'Progresso',
    duration: 'Durata',
    startedAt: 'Iniziato il',
    completedAt: 'Completato il',
    status: {
      waiting: 'In coda',
      pending: 'In attesa',
      running: 'In corso',
      completed: 'Completato',
      failed: 'Fallito',
      cancelled: 'Annullato',
      paused: 'In pausa'
    },
    types: {
      quick: 'Scansione rapida',
      full: 'Scansione completa',
      stealth: 'Scansione stealth',
      aggressive: 'Scansione aggressiva',
      custom: 'Scansione personalizzata',
      iot_scan: 'Scansione IoT',
      ot_scan: 'Scansione OT/SCADA',
      full_autonomous: 'Autonomo completo',
      full_auto: 'Autonomo completo',
      full_automation: 'Autonomo completo',
      network_discovery: 'Scoperta rete',
      vulnerability_scan: 'Scansione vulnerabilità',
      expert: 'Scansione esperta',
      api_pentest: 'Pentest API',
      ad_pentest: 'Pentest Active Directory',
      ad_scan: 'Scansione Active Directory',
      wifi_pentest: 'Pentest Wi-Fi',
      social_engineering: 'Ingegneria sociale',
      red_team: 'Red Team',
      phishing: 'Campagna di phishing'
    },
    phases: {
      discovery: 'Scoperta',
      portScan: 'Scansione porte',
      serviceDetection: 'Rilevamento servizi',
      vulnScan: 'Scansione vulnerabilità',
      exploitation: 'Sfruttamento',
      reporting: 'Reportistica'
    },
    stealthMode: {
      title: 'Modalità Stealth',
      description: 'Tecniche di evasione IDS/IPS',
      none: 'Nessuno',
      noneDesc: 'Scansione veloce, facilmente rilevabile',
      basic: 'Base',
      basicDesc: 'Pacchetti frammentati',
      advanced: 'Avanzato',
      advancedDesc: 'Tempistica lenta + spoofing',
      paranoid: 'Paranoico',
      paranoidDesc: 'Massima evasione (molto lento)',
      warning: 'Le modalità stealth utilizzano tecniche di evasione per evitare il rilevamento IDS/IPS'
    },
    hosts: 'Host',
    ports: 'Porte',
    services: 'Servizi',
    openPorts: 'Porte aperte',
    closedPorts: 'Porte chiuse',
    filteredPorts: 'Porte filtrate',
    noResults: 'Nessun risultato trovato',
    exportResults: 'Esporta risultati',
    scanFailed: 'Scansione fallita',
    genericError: 'Si è verificato un errore durante l\'esecuzione della scansione. Ciò potrebbe essere dovuto a problemi di connettività di rete, obiettivi non raggiungibili o risorse insufficienti.',
    technicalDetails: 'Dettagli tecnici',
    retryScan: 'Riprova questa scansione',
    // Cleanup mode
    cleanup: 'Pulizia',
    cleanupTitle: 'Pulizia post-pentest',
    cleanupDescription: 'Questa azione rimuoverà tutte le tracce lasciate dal pentest, inclusi:',
    cleanupSessions: 'Sessioni di exploitation attive',
    cleanupPersistence: 'Meccanismi di persistenza installati',
    cleanupFiles: 'File temporanei ed evidenze',
    cleanupLogs: 'Log di esecuzione APT',
    cleanupPreview: 'Anteprima pulizia',
    sessionsCount: 'Sessioni',
    withPersistence: 'Con persistenza',
    aptExecutions: 'Esecuzioni APT',
    evidenceFiles: 'File di evidenza',
    evidenceSize: 'Dimensione evidenze',
    cleanNow: 'Pulisci ora',
    archiveAndClean: 'Archivia e pulisci',
    cleaning: 'Pulizia...',
    cleanupSuccess: 'Pulizia completata con successo',
    cleanupPartial: 'Pulizia parziale (alcuni errori)',
    cleanupFailed: 'Pulizia fallita',
    sessionsClosed: 'Sessioni chiuse',
    persistenceRemoved: 'Persistenza rimossa',
    filesCleaned: 'File puliti',
    aptLogsCleaned: 'Log APT puliti',
    evidenceArchived: 'Evidenze archiviate',
    cleanupWarning: '⚠️ Questa azione è irreversibile. Assicurati di aver salvato i dati importanti.',
    status: {
      queued: 'In coda',
      stopped: 'Interrotto',
      scheduled: 'Pianificato',
    },
    filters: {
      all: 'Tutti',
      failed: 'Falliti',
    },
    types: {
      ai_scan: 'Scansione IA',
      cloud_scan: 'Scansione Cloud',
    },
    stealthMode: {
      basicTime: 'La scansione richiederà circa 2x più tempo',
      advancedTime: 'La scansione richiederà circa 5x più tempo',
      paranoidTime: 'La scansione richiederà circa 10x più tempo',
    },
    advancedDiscoveryOptions: 'Opzioni di scoperta avanzate',
    configureScan: 'Configura i parametri dettagliati della scansione',
    steps: {
      targetType: 'Obiettivo e Tipo',
      networkMode: 'Modalità di Rete',
      scanOptions: 'Opzioni',
      advanced: 'Avanzato',
      review: 'Verifica',
    },
    allScans: 'Totale',
    activeScans: 'Scansioni attive',
    withSuccess: 'Completate con successo',
    vulnerabilities: 'Vulnerabilità',
    discovered: 'Host rilevati',
    toReview: 'Da verificare',
    sortByDate: 'Ordina per data',
    sortByStatus: 'Ordina per stato',
    sortByVulns: 'Ordina per vuln.',
    tooltips: {
      totalScans: 'Totale Scansioni',
      totalScansDesc: 'Numero totale di scansioni avviate sulla piattaforma. Include tutte le scansioni: in corso, completate e fallite.',
      runningScans: 'Scansioni in Corso',
      runningScansDesc: 'Scansioni attualmente in esecuzione. Analizzano i target per rilevare porte aperte, servizi e vulnerabilità.',
      completedScans: 'Scansioni Completate',
      completedScansDesc: 'Scansioni che si sono concluse con successo. I risultati sono disponibili per la consultazione e l\'esportazione nei report.',
      vulnerabilities: 'Vulnerabilità Rilevate',
      vulnerabilitiesDesc: 'Totale delle falle di sicurezza identificate. I badge indicano il numero di vulnerabilità critiche e alte che richiedono attenzione immediata.',
      hostsDiscovered: 'Host Scoperti',
      hostsDiscoveredDesc: 'Numero di macchine (server, postazioni, apparecchiature di rete) rilevate durante le scansioni. Ogni host può avere più porte e servizi esposti.',
      failedScans: 'Scansioni Fallite',
      failedScansDesc: 'Scansioni fallite (target irraggiungibile, timeout, problema di rete). Consulta i dettagli per capire la causa e rilanciarle se necessario.',
    },
    notFound: 'Scansione non trovata',
    notFoundDesc: 'La scansione richiesta non esiste o è stata eliminata',
    backToScans: 'Torna alle scansioni',
    consoleLive: 'Console in diretta',
    consoleCompleted: 'Console (Completata)',
    consoleFailed: 'Console (Fallita)',
    consoleTitle: 'Console',
    scanCompletedMessage: '✓ Completata!',
    scanFailedMessage: '✗ Scansione fallita',
    stepCompleted: 'Completato',
    stepWaiting: 'In attesa',
    stepInProgress: 'Scansione in corso',
    timestampStarted: 'Avviata',
    timestampCompleted: 'Completata',
    aiQuotaExceeded: 'Quota di scansioni IA raggiunta',
    aiScansUsed: 'Scansioni IA usate',
    upgradeOptions: 'Opzioni per continuare',
    callSylink: 'Chiama il servizio clienti SYLink:',
    upgradePlan: 'Passa a un piano superiore per scansioni IA illimitate',
    viewPlans: 'Vedi i piani',
    networkDiscovery: 'Scoperta di Rete',
    networkDiscoveryDesc: 'Scoperta rapida di host e porte',
    vulnerabilityScan: 'Scansione di Vulnerabilità',
    vulnerabilityScanDesc: 'Analisi approfondita delle vulnerabilità',
    fullAutonomous: 'Autonomo completo',
    fullAutonomousDesc: 'Valutazione di sicurezza completa',
    placeholders: {
      target: '192.168.1.0/24 o esempio.com',
      targetExamples: 'Esempi: 192.168.1.1, 192.168.1.0/24, esempio.com, 10.0.0.0/8',
      customPorts: 'Es: 80,443,8080-8090',
      excludeHosts: 'Es: 192.168.1.1,192.168.1.5',
    },
    searchPlaceholder: 'Cerca per Obiettivo o Tipo...',
    table: {
      name: 'Nome',
      score: 'Punteggio',
      target: 'Obiettivo',
      client: 'Cliente',
      type: 'Tipo',
      status: 'Stato',
      vulnerabilities: 'Vuln.',
      date: 'Data',
      actions: 'Azioni',
    },
    noCaptures: 'Nessuna acquisizione',
    noLogsAvailable: 'Nessun log disponibile',
    waitingForLogs: 'In attesa dei log...',
    discoveringHosts: 'Scoperta host in corso...',
    noHostDiscovered: 'Nessun host scoperto',
    analyzingVulns: 'Analisi vulnerabilità in corso...',
    noVulnDetected: 'Nessuna vulnerabilità rilevata',
    noCriticalVulns: 'Nessuna vulnerabilità critica rilevata.',
    noAttackScenario: 'Nessuno scenario di attacco critico identificato.',
    noWeakness: 'Nessuna debolezza critica rilevata',
    noContent: 'Nessun contenuto disponibile',
    noData: 'Nessun dato disponibile',
    noVpnSession: 'Nessuna sessione VPN è attualmente attiva per questo workspace.',
    loadingExecutiveReport: 'Caricamento del report esecutivo...',
    saveSchedule: 'Salva la pianificazione',
    noActiveScan: 'Nessuna scansione in corso',
    noScanFound: 'Nessuna scansione trovata',
    noScanResult: 'Nessun risultato per "{query}"',
    noScanStatus: 'Nessuna scansione con lo stato "{status}"',
    noVulnerabilities: 'Nessuna vulnerabilità',
    loadingError: 'Errore di caricamento',
    deleteFailedScans: 'Elimina i falliti',
    deleteFailedScansTitle: 'Elimina tutte le scansioni fallite',
    confirmDeleteFailed: 'Eliminare {count} scansione/i fallita/e?',
    deleteScansError: 'Errore durante l\'eliminazione delle scansioni',
    associateScansError: 'Errore durante l\'associazione delle scansioni',
    removeScansError: 'Errore durante la rimozione della scansione',
    restartScansError: 'Errore durante il rilancio delle scansioni',
    restartError: 'Errore durante il rilancio',
    loadScansError: 'Errore durante il caricamento delle scansioni',
    networkError: 'Errore di rete. Verifica la connessione e riprova.',
    validateScansError: 'Errore durante la validazione delle scansioni',
    imageLoadError: 'Errore di caricamento immagine',
    noWorkspaceForScan: 'Nessun workspace associato a questa scansione. Seleziona un cliente dalla pagina Clienti, poi rilancia la scansione.',
    pdfGenerationError: 'Errore generazione PDF',
    scheduleSaved: 'Salva la pianificazione',
    scheduleError: 'Errore durante la creazione della pianificazione',
    generatePdfError: 'Errore durante la generazione del PDF',
    errors: {
      createFailed: 'Errore nella creazione della scansione',
      serverError: 'Errore del server durante la scansione',
      workspaceRequired: 'Workspace richiesto per avviare una scansione'
    },
    screenshotLoadError: 'Errore di caricamento acquisizione',
  },

  // Workspaces
  workspaces: {
    title: 'Aree clienti',
    newWorkspace: 'Nuova area',
    editWorkspace: 'Modifica area',
    deleteWorkspace: 'Elimina area',
    workspaceDetails: 'Dettagli area',
    clientName: 'Nome cliente',
    clientInfo: 'Informazioni cliente',
    members: 'Membri',
    addMember: 'Aggiungi membro',
    removeMember: 'Rimuovi membro',
    scansCount: 'Numero di scansioni',
    lastActivity: 'Ultima attività',
    created: 'Creato il',
    shareWorkspace: 'Condividi area',
    archiveWorkspace: 'Archivia area',
    noWorkspaces: 'Nessuna area cliente',
    // Form labels
    siret: 'SIRET',
    siretPlaceholder: 'Es: 123 456 789 00001',
    siren: 'SIREN',
    sirenPlaceholder: 'Es: 123 456 789',
    // Additional workspace keys
    scans: 'Scansioni',
    hosts: 'Host',
    vulnerabilities: 'Vulnerabilità',
    attackPaths: 'Percorsi di attacco',
    successfulScans: 'Scansioni riuscite',
    company: 'Azienda',
    legalForm: 'Forma giuridica',
    address: 'Indirizzo',
    city: 'Città',
    website: 'Sito web',
    shareDescription: 'Condividi questa area con i tuoi clienti o collaboratori',
    manageShares: 'Gestisci condivisioni',
    mainContact: 'Contatto principale',
    contact: 'Contatto',
    signed: 'Firmato',
    pending: 'In attesa',
    draft: 'Bozza',
    contractSigned: 'Contratto firmato',
    pendingContract: 'Contratto in attesa',
    noContract: 'Nessun contratto',
    noScans: 'Nessuna scansione associata',
    noScansHint: 'Associa una scansione esistente o avviane una nuova dalla pagina Scansioni',
    noHosts: 'Nessun host',
    noVulnerabilities: 'Nessuna vulnerabilità',
    noAttackPaths: 'Nessun percorso di attacco',
    // Network stats
    vulnerable: 'Vulnerabili',
    subnets: 'Sottoreti',
    services: 'Servizi',
    noAttackTree: 'Nessun albero di attacco',
    noVPN: 'Nessun VPN configurato',
    // AI Analysis
    aiAnalysis: 'Analisi IA',
    generateSummary: 'Genera riepilogo',
    launchAiAnalysis: 'Avvia analisi IA',
    analysisInProgress: 'Analisi in corso...',
    completeAnalysis: 'Analisi completa e Soluzioni',
    aggregatedData: 'Dati aggregati',
    riskAnalysis: 'Analisi dei rischi',
    clickToGenerateSummary: 'Clicca su "Genera riepilogo" per ottenere un\'analisi IA',
    noAnalysisAvailable: 'Nessuna analisi disponibile',
    clickToLaunchAnalysis: 'Clicca sul pulsante sopra per avviare l\'analisi IA',
    launchScanToDiscoverNetwork: 'Avvia una scansione per scoprire la rete',
    critical: 'Critiche',
    high: 'Alte',
    download: 'Scarica',
    deleteStoredCredentials: 'Elimina credenziali salvate',
    useStoredCredentials: 'usa credenziali salvate',
    enterVpnUsername: 'Inserisci il tuo nome utente VPN',
    enterVpnPassword: 'Inserisci la tua password VPN',
    // VPN Modal
    actionPlan: 'Piano d\'azione & Soluzioni',
    noDocuments: 'Nessun documento generato per questo workspace',
    reportsWillAppear: 'I report appariranno qui dopo la generazione',
    vpnCredentials: 'Credenziali VPN',
    requiresAuthentication: 'richiede autenticazione',
    storedCredentials: 'Credenziali salvate',
    clickToUseCredentials: 'Clicca su "Connetti" per usare queste credenziali',
    connect: 'Connetti',
    cancel: 'Annulla',
    username: 'Nome utente',
    password: 'Password',
    saveCredentials: 'Salva queste credenziali',
    saveCredentialsSecurely: 'Salva credenziali in modo sicuro',
    credentialsStorageInfo: 'Le credenziali saranno crittografate (AES-256) e memorizzate nel database. Verranno utilizzate automaticamente per le future connessioni VPN.',
    saving: 'Salvataggio...',
    connecting: 'Connessione...',
    server: 'Server',
    protocol: 'Protocollo',
    noVulnsToFix: 'Nessuna vulnerabilità da correggere',
    connectionInProgress: 'Connessione in corso...',
    connectionFailed: 'Connessione fallita',
    generateActionPlan: 'Genera piano d\'azione',
    clickToGenerateActionPlan: 'Clicca su "Genera piano d\'azione" per ottenere raccomandazioni',
    vpnConnected: 'VPN connesso! IP:',

    // Workspace Switcher
    selectTitle: 'Seleziona workspace',
    selectDescription: 'Scegli un workspace per continuare',
    searchPlaceholder: 'Cerca workspace...',
    noWorkspacesYet: 'Nessun workspace ancora',
    noResults: 'Nessun workspace corrispondente',
    createFirst: 'Crea il tuo primo workspace',
    createNew: 'Crea nuovo',
    continue: 'Continua',
    switchError: 'Errore nel cambio di workspace',
    scan: 'scansione',
    scans: 'scansioni',
    select: 'Seleziona workspace',
    manageAll: 'Gestisci workspace',
    noWorkspaces: 'Nessun workspace trovato',
    switching: 'Cambio in corso...',
    switchSuccess: 'Workspace cambiato con successo',
    autoSelected: 'Workspace selezionato automaticamente',
    pleaseSelect: 'Seleziona un workspace per continuare',
    activeWorkspace: 'Workspace attivo',
    subtitle: 'Gestisci le tue aree clienti e le loro configurazioni',
    deleteWorkspaceError: "Errore durante l'eliminazione dell'area",
    deleteWorkspaceSuccess: 'Area eliminata con successo',
    invalidIdentifier: 'Inserisci un identificatore valido',
    workspaceName: "Nome dell'area",
    companyName: "Nome dell'azienda",
    searchCompany: "Cerca un'azienda",
    postalCode: 'Codice postale',
    nafCode: 'Codice NAF',
    capital: 'Capitale',
    employees: 'Personale',
    companyLogo: "Logo dell'azienda",
    noLogo: 'Nessun logo',
    vpnConfiguration: 'Configurazione VPN',
    contractStatus: 'Stato del contratto',
    sendContract: 'Invia il contratto',
    readyForTests: 'Pronto per i test',
    upload: 'Carica',
    country: 'Paese',
    contractNotSigned: 'Contratto non firmato',
    analyzingInProgress: 'Analisi in corso...',
    generatingAiSummary: 'Generazione del riepilogo IA',
    noScansToAssociate: 'Nessuna scansione disponibile da associare',
    associateScan: 'Associa una scansione',
    networkMap: 'Mappa di Rete',
    // Contact form labels
    contactFullName: 'Nome completo',
    contactFunction: 'Funzione',
    contactEmail: 'E-mail',
    contactPhone: 'Telefono',
    contactResponsibleDescription: 'Persona responsabile del progetto pentest',
    logoUsedInReports: 'Utilizzato nei report di pentest',
    // Schedules
    scanSchedules: 'Pianificazioni di scansione',
    addSchedule: 'Aggiungi pianificazione',
    noSchedules: 'Nessuna pianificazione configurata',
    noSchedulesHint: 'Clicca su "Aggiungi pianificazione" per automatizzare le scansioni',
    createSchedule: 'Crea pianificazione',
    scheduleName: 'Nome della pianificazione',
    scheduleNamePlaceholder: 'Es: Scansione settimanale di sicurezza',
    targets: 'Target',
    targetsPlaceholder: '192.168.1.0/24, esempio.com',
    targetsCommaSeparated: 'Target * (separati da virgole)',
    scanType: 'Tipo di scansione',
    frequency: 'Frequenza',
    timeOfDay: 'Ora di esecuzione',
    daysOfWeek: 'Giorni della settimana',
    autoGenerateReport: 'Genera il report automaticamente',
    sendNotifications: 'Invia notifiche',
    notificationRecipients: 'Destinatari delle notifiche (e-mail, separati da virgole)',
    creating: 'Creazione...',
    // Scan types
    scanTypeQuick: 'Rapida',
    scanTypeFull: 'Completa',
    scanTypeVulnerability: 'Vulnerabilità',
    scanTypePortScan: 'Scansione porte',
    scanTypeWebScan: 'Scansione Web',
    // Frequencies
    frequencyDaily: 'Quotidiana',
    frequencyWeekly: 'Settimanale',
    frequencyBiweekly: 'Bimensile',
    frequencyMonthly: 'Mensile',
    frequencyQuarterly: 'Trimestrale',
    // Days
    dayMon: 'Lun',
    dayTue: 'Mar',
    dayWed: 'Mer',
    dayThu: 'Gio',
    dayFri: 'Ven',
    daySat: 'Sab',
    daySun: 'Dom',
    // Stats labels
    schedulesCount: 'Pianificazioni',
    successfulRuns: 'Esecuzioni riuscite',
    runNow: 'Esegui ora',
    nextRun: 'Prossima',
    // Remediation Tracker
    remediationTitle: 'Monitoraggio della Remediation',
    remediationProgress: 'Progresso globale',
    remediationVulnsFixed: 'vulnerabilità remediate',
    remediationNoVulns: 'Nessuna vulnerabilità trovata',
    remediationRescanTitle: 'Avvia una nuova scansione di verifica',
    remediationAllStatuses: 'Tutti gli stati',
    remediationAllSeverities: 'Tutte le gravità',
    remediationResults: 'risultati',
    remediationSeverity: 'Gravità',
    remediationVulnerability: 'Vulnerabilità',
    remediationHost: 'Host',
    remediationStatus: 'Stato',
    remediationUpdated: 'Aggiornato',
    remediationActions: 'Azioni',
    remediationPrevious: '← Precedente',
    remediationNext: 'Successivo →',
    remediationCritical: 'Critica / Alta — non trattate',
    remediationSeverityBreakdown: 'Ripartizione per gravità',
    remediationStatusUpdate: 'Stato aggiornato',
    remediationStatusError: "Errore durante l'aggiornamento",
    remediationLoadDashboardError: 'Errore caricamento dashboard',
    remediationLoadVulnsError: 'Errore caricamento vulnerabilità',
    remediationRefresh: 'Aggiorna',
    remediationCertificate: 'Certificato di chiusura',
    remediationSearch: 'Cerca...',
    // Status labels
    statusOpen: 'Aperta',
    statusInProgress: 'In corso',
    statusFixed: 'Corretta (da verificare)',
    statusVerified: 'Verificata ✓',
    statusAcceptedRisk: 'Rischio accettato',
    statusWontFix: 'Non verrà corretta',
    // Severity labels
    severityCritical: 'Critica',
    severityHigh: 'Alta',
    severityMedium: 'Media',
    severityLow: 'Bassa',
    severityInfo: 'Info',
    // KPI labels
    kpiOpen: 'Aperte',
    kpiInProgress: 'In corso',
    kpiToVerify: 'Da verificare',
    kpiVerified: 'Verificate',
    kpiAcceptedRisk: 'Rischio accettato',
    kpiTotal: 'Totale',
    // VPN
    saveUid: "Salva l'UID",
    noVpnCredentials: 'Nessuna credenziale VPN salvata - accedi per salvarne',
    noVpnRoutes: 'Nessuna route personalizzata configurata',
    add: 'Aggiungi',
    noScanReports: 'Nessun report di scansione disponibile',
    errorAnalysis: 'Errore di analisi',
    noBusinessAnalysis: 'Nessuna analisi aziendale disponibile',
    noVpnConfig: 'Nessuna configurazione VPN',
    deleteReport: 'Elimina il report',
    vpnRouteCount: '{{count}} route',
    noRoutes: 'Nessuna route',
    // WorkspaceManager
    deleteVpnLogo: 'Elimina il logo',
    modifyWorkspace: 'Modifica il workspace',
    modifyWorkspaceDesc: 'Modifica le informazioni del cliente "{{name}}"',
    modifyVpnDesc: 'Modifica la VPN associata per le scansioni di questo cliente',
    noVpnRequired: 'Nessuna configurazione VPN richiesta',
    noVpnAvailable: 'Nessuna configurazione VPN disponibile',
    createWorkspaceBtn: 'Crea il workspace',
    vpnUploadError: "Errore durante il caricamento della VPN",
    companyNotFound: 'Nessuna azienda trovata per "{{term}}"',
    noCompanyFound: 'Nessuna azienda trovata',
    companySearchError: 'Errore durante la ricerca',
    scheduleError: 'Errore durante la pianificazione della scansione',
    noCompletedScans: 'Nessuna scansione completata',
    allWorkspaces: 'Tutti i workspace',
    contractCreateError: 'Errore durante la creazione del contratto',
  },

  // Vulnerabilities
  vulnerabilities: {
    title: 'Vulnerabilità',
    subtitle: 'Analisi e gestione delle vulnerabilità rilevate',
    vulnerability: 'Vulnerabilità',
    severity: 'Gravità',
    severities: {
      critical: 'Critica',
      high: 'Alta',
      medium: 'Media',
      low: 'Bassa',
      info: 'Informativa'
    },
    cve: 'CVE',
    cvss: 'Punteggio CVSS',
    affected: 'Interessato',
    solution: 'Soluzione',
    references: 'Riferimenti',
    evidence: 'Prove',
    exploitable: 'Sfruttabile',
    verified: 'Verificato',
    falsePositive: 'Falso positivo',
    validation: {
      confirmed: 'Confermato sfruttabile',
      theoretical: 'Teorico',
      not_exploitable: 'Non sfruttabile',
      unvalidated: 'Non validato',
      poc_title: 'Prova di Concetto',
      narrative: 'Narrativa di sfruttamento',
      exploit_path: 'Percorso di exploit',
      prerequisites: 'Prerequisiti',
    },
    markAsFixed: 'Segna come risolto',
    noVulnerabilities: 'Nessuna vulnerabilità trovata',
    export: 'Esporta vulnerabilità',
    distributionBySeverity: 'Distribuzione per Gravità',
    priority: {
      auto: 'Automatico',
    },
    // Attack Chain
    attackChain: {
      title: 'Classifica delle Catene di Attacco',
      subtitle: 'Analisi dei rischi multi-vulnerabilità per penetrare il target',
      riskScore: 'Punteggio di rischio',
      vulnCount: 'vulnerabilità',
      attackPath: 'Percorso di attacco verso l\'obiettivo',
      // Chart
      chartTitle: 'Distribuzione delle Vulnerabilità',
      chartSubtitle: 'Analisi statistica delle CVE rilevate',
      bySeverity: 'Distribuzione per Severità',
      keyMetrics: 'Metriche Chiave',
      totalVulns: 'Totale CVE',
      avgCvss: 'CVSS Medio',
      criticalHigh: 'Critico + Alto',
      affectedHosts: 'Host Colpiti',
      topCves: 'Top CVE per CVSS',
      // Stages
      stages: {
        initialAccess: 'Accesso Iniziale',
        privEscalation: 'Escalation di Privilegi',
        persistence: 'Persistenza',
        objective: 'Obiettivo'
      },
      exploitVia: 'Sfruttamento via',
      escalationVia: 'Escalation via',
      maintenanceVia: 'Persistenza via',
      fullCompromise: 'Compromissione completa del sistema',
      adminAccess: 'Accesso admin possibile',
      initialSystemAccess: 'Accesso iniziale al sistema',
      // Risk Factors
      riskFactors: 'Fattori di rischio',
      factors: {
        multiVuln: 'Multi-vulnerabilità',
        multiVuln5: '{count} vuln concatenabili',
        multiVuln3: '{count} vuln su questo host',
        criticalHighCombo: 'Combo Critical + High',
        rce: 'RCE potenziale',
        authBypass: 'Bypass auth possibile',
        privEsc: 'Escalation privilegi',
        exposed: 'Servizi esposti',
        highCvss: 'CVSS medio {score}'
      },
      // Ratings
      ratingCritical: 'CRITICO',
      ratingHigh: 'ALTO',
      ratingMedium: 'MEDIO',
      ratingLow: 'BASSO',
      ratingSafe: 'SICURO',
      // Details
      criticalPath: 'PERCORSO CRITICO',
      vulnsInChain: 'Vulnerabilità in questa catena',
      noChains: 'Nessuna catena di attacco rilevata',
      noVulnsDesc: 'Nessuna vulnerabilità trovata per analizzare i percorsi di attacco.',
      viewDetails: 'Vedi dettagli',
      multiVulnWarning: 'Rischio aumentato: vulnerabilità multiple concatenabili',
      // Recommendations
      recommendation: 'Raccomandazione di sfruttamento',
      recoCritical: 'Questo target presenta un rischio critico. La combinazione di {count} vulnerabilità consente la compromissione completa del sistema. Massima priorità per la remediation.',
      recoHigh: 'Alto rischio di compromissione. Le vulnerabilità combinate offrono un percorso di attacco praticabile. Azione correttiva raccomandata al più presto.',
      recoMedium: 'Rischio moderato. Alcune vulnerabilità potrebbero essere concatenate per lo sfruttamento. Monitorare e correggere secondo priorità.',
      recoLow: 'Rischio basso. Le vulnerabilità presenti hanno impatto limitato e sono difficili da sfruttare in catena.',
      // Stats
      criticalPaths: 'Percorsi Critici',
      highRisk: 'Rischio Alto',
      multiVuln: 'Multi-Vuln (3+)',
      hostsAnalyzed: 'Host Analizzati',
      avgScore: 'Punteggio Medio',
      // Info
      infoText: 'Questa classifica identifica gli host più vulnerabili analizzando le combinazioni di vulnerabilità sfruttabili per raggiungere gli obiettivi di penetrazione.',
      // Legend
      legendCritical: 'Critico (80-100)',
      legendHigh: 'Alto (60-79)',
      legendMedium: 'Medio (40-59)',
      legendLow: 'Basso (20-39)',
      legendSafe: 'Sicuro (0-19)',
      analysisTitle: 'Analisi dei Rischi',
    },
    aiAssistant: 'Assistente IA',
    aiAssistantDesc: 'Analizzare e sfruttare le vulnerabilità in modo autonomo',
    searchPlaceholder: 'Cerca per titolo, CVE, descrizione...',
    noVulnerabilitiesFound: 'Nessuna vulnerabilità trovata nelle scansioni.',
    noVulnerabilitiesBySeverity: 'Nessuna vulnerabilità di gravità {severity} trovata.',
    customActionPlaceholder: 'Es: shell_inversa, estrazione_creds, backdoor...',
    actionPanel: {
      title: 'Azioni sulla vulnerabilità',
    },
    prioritization: 'Priorizzazione',
    prioritizationDesc: 'Urgenza e criticità',
    exploitabilityLabel: 'Sfruttabilità',
    exploitabilityDesc: 'Vulnerabilità sfruttabili',
    summaryLabel: 'Sommario',
    summaryDesc: 'Panoramica generale',
    remediationLabel: 'Remediation',
    remediationDesc: 'Piano di correzione',
    aiQueryPlaceholder: 'Poni una domanda sulle vulnerabilità...',
    analyzeBtn: 'Analizza',
    pocAutoTitle: 'PoC Auto - Generazione ed Esecuzione',
    pocSelectVuln: 'Seleziona una vulnerabilità',
    noCriticalHighForPoC: 'Nessuna vulnerabilità critica/alta per PoC',
    pocGeneratedCode: 'Codice PoC Generato',
    copyCta: 'Copia',
    executeBtn: 'Esegui',
    executingBtn: 'Esecuzione...',
    pocGenerating: 'Generazione del PoC...',
    pocSelectPrompt: 'Seleziona una vulnerabilità per generare un PoC',
    pocResult: 'Risultato:',
    pocActionInProgress: 'Azione in corso...',
    hideAttackTree: "Nascondi Albero di Attacco",
    showAttackTree: "Mostra Albero di Attacco",
    viewWorkspace: 'Vedi Workspace',
    generatingAttackTree: 'Generazione albero di attacco...',
    noAttackTreeData: "Nessun dato disponibile per l'albero di attacco",
    ensureWorkspaceHasScans: 'Assicurati che il workspace abbia scansioni con vulnerabilità',
    pageOfTotal: 'Pagina {current} / {total} — {count} vulnerabilità',
    prevPage: '← Precedente',
    nextPage: 'Successivo →',
    quickActionsTitle: 'Azioni Rapide',
    newScanBtn: 'Nuova scansione',
    generateReportBtn: 'Genera report',
    exportJsonBtn: 'Esporta JSON',
    exportCsvBtn: 'Esporta CSV',
    aiAnalysisTitle: 'Analisi IA',
    selectedLabel: 'Selezionato:',
    analyzingLabel: 'Analisi...',
    analyzeWithAI: 'Analizza con IA',
    impactLabel: 'Impatto',
    recommendationsLabel: 'Raccomandazioni',
    selectVulnForAnalysis: "Seleziona una vulnerabilità per ottenere un'analisi IA dettagliata.",
    statisticsTitle: 'Statistiche',
    cvssAvg: 'CVSS Medio',
    exploitableCount: 'Sfruttabili',
    hostsAffected: 'Host Colpiti',
    actionsHistory: 'Storico delle Azioni ({count})',
    clearHistory: 'Cancella storico',
    viewScan: 'Vedi scansione',
    addToReport: 'Aggiungi al report',
    severityLabel: 'Gravità',
    cveLabel: 'CVE',
    cvssLabel: 'CVSS',
    targetLabel: 'Target',
    actionsAvailable: 'Azioni disponibili',
    exploitAction: 'Sfruttamento',
    exploitActionDesc: 'Tentare di sfruttare questa vulnerabilità per ottenere accesso',
    injectionAction: 'Iniezione',
    injectionActionDesc: "Eseguire un'iniezione (SQL, comando, XSS, ecc.)",
    enumerationAction: 'Enumerazione',
    enumerationActionDesc: 'Raccogliere più informazioni su questa falla',
    privescAction: 'Escalation',
    privescActionDesc: "Tentare un'escalation di privilegi",
    pivotAction: 'Pivot',
    pivotActionDesc: 'Pivotare verso altri sistemi della rete',
    exfilAction: 'Estrazione',
    exfilActionDesc: 'Estrarre dati sensibili attraverso questa falla',
    aiWizardBtn: 'Wizard IA',
    aiWizardDesc: "L'IA analizza il CVE e avvia il wizard di sfruttamento adeguato",
    captureProofBtn: 'Cattura Prova',
    captureProofDesc: 'Catturare una prova di sfruttamento per il report',
    customActionTitle: 'Azione personalizzata',
    executeAction: 'Esegui',
    actionsAutoIntegrated: 'I risultati delle azioni saranno automaticamente integrati nel report della scansione',
    editPriority: 'Modifica Priorità',
    autoSeverity: 'Gravità automatica:',
    manualPriority: 'Priorità manuale',
    usesCVSS: 'Usa CVSS',
    priorityCritical: 'Critica',
    priorityHigh: 'Alta',
    priorityMedium: 'Media',
    priorityLow: 'Bassa',
    priorityInfo: 'Info',
    noteOptional: 'Nota (opzionale)',
    explainPriorityChange: 'Spiega perché hai cambiato la priorità...',
    savePriority: 'Salva',
    savingPriority: 'Salvataggio...',
    aiWizardTitle: 'Wizard IA - Analisi di Vulnerabilità',
    wizardRecommended: "Wizard raccomandato dall'IA",
    vulnSummaryTitle: 'Sommario della vulnerabilità',
    launchWizard: 'Avvia {name}',
    orChooseWizard: 'O scegli un altro wizard:',
    aiAnalyzing: 'Analisi IA in corso...',
    aiDeterminingWizard: "L'IA determina il miglior wizard di sfruttamento",
    screenshotsTitle: 'Acquisizioni di Prova ({count})',
    noScreenshots: 'Nessuna acquisizione di prova',
    screenshotsAutoAdded: 'Le acquisizioni verranno aggiunte automaticamente ai report',
    wizardReasonAD: "Questa vulnerabilità è collegata ad Active Directory, Kerberos o servizi Windows. Il wizard AD consente di sfruttare le falle di autenticazione e il movimento laterale.",
    wizardReasonAPI: "Questa vulnerabilità riguarda un'API o un servizio web. Il wizard API consente di testare endpoint, autenticazione e iniezioni.",
    wizardReasonIoT: "Questa vulnerabilità colpisce un dispositivo IoT o un protocollo industriale. Il wizard IoT è specializzato nell'analisi degli oggetti connessi.",
    wizardReasonOT: "Questa vulnerabilità riguarda un sistema industriale o SCADA. Il wizard OT è progettato per l'analisi sicura degli ambienti industriali.",
    wizardReasonExpert: "Questa vulnerabilità critica richiede un'analisi approfondita. La modalità Expert offre il controllo totale sulle tecniche di sfruttamento.",
    wizardReasonAI: "L'IA analizzerà questa vulnerabilità e determinerà automaticamente la migliore strategia di sfruttamento.",
    aiSummaryTemplate: 'Questa vulnerabilità {severity} colpisce {target}. Potenzialmente consente a un attaccante di sfruttare {title}.',
    aiImpactCritical: 'Impatto critico sulla riservatezza e integrità del sistema',
    aiImpactHigh: 'Impatto alto - richiede attenzione immediata',
    aiImpactMedium: 'Impatto moderato - da correggere al più presto',
    aiImpactLow: 'Impatto basso - da monitorare',
    aiRec1: 'Applicare le patch di sicurezza disponibili',
    aiRec2: "Limitare l'accesso di rete al servizio interessato",
    aiRec3: 'Implementare un monitoraggio rafforzato',
    aiRec4CVE: 'Consultare i dettagli CVE: {cve_id}',
    aiRec4NoCVE: "Eseguire un'analisi approfondita",
    aiExploitHigh: 'Alta',
    aiExploitMedium: 'Media',
    aiExploitLow: 'Bassa',
    aiExploitUnknown: 'Non valutata',
    aiVectorRemote: 'Rete (Remoto)',
    aiVectorAdjacent: 'Adiacente',
    aiVectorLocal: 'Locale',
    exploitabilityMetric: 'Sfruttabilità',
    attackDifficulty: 'Difficoltà di attacco',
    detectionRisk: 'Rischio di rilevamento',
    exploitMaturity: "Maturità dell'exploit",
    riskAssessment: 'Valutazione del rischio',
    aiRecommendations: 'Raccomandazioni IA',
    aiAnalyzingVuln: "L'IA sta analizzando la vulnerabilità...",
    clickToGetRecommendations: 'Clicca su "Vedi" per ottenere le raccomandazioni IA',
    autoAnalysisDesc: 'Analisi automatica dei vettori di attacco e strategie di sfruttamento',
    analyzeLabel: 'Analisi...',
    viewLabel: 'Vedi',
    generateExploit: 'Genera',
    generatingExploit: 'Generazione...',
    executeOnTarget: 'Esegui su target',
    executingExploit: 'Esecuzione...',
    copyCode: 'Copia',
    codeCopied: 'Codice copiato negli appunti!',
    langLabel: 'Linguaggio:',
    targetLabel2: 'Target:',
    aiGeneratingExploit: "L'IA genera un exploit personalizzato...",
    aiExploitAnalysisDesc: 'Analisi del CVE, creazione del payload, ottimizzazione...',
    clickGenerateExploit: 'Clicca su "Genera" per creare un exploit IA personalizzato',
    thenExecuteExploit: "Poi \"Esegui su target\" per lanciare l'attacco",
    autoExploitGenDesc: 'Generazione automatica di codice di sfruttamento adattato al target',
    exploitProofs: 'Prove di Sfruttamento ({count})',
    captureN: 'Acquisizione {n}:',
    capturesEnregistrees: '{count} acquisizioni di prova registrate',
    exploitReussie: 'SFRUTTAMENTO RIUSCITO',
    exploitEchec: 'FALLIMENTO',
    dureeDuration: 'Durata',
    exportPdf: 'Esporta PDF',
    impactAnalysis: "Analisi dell'Impatto",
    accessVector: 'Vettore di accesso',
    accessComplexity: 'Complessità di accesso',
    requiredAuth: 'Autenticazione richiesta',
    userInteractionLabel: 'Interazione utente',
    confidentialityImpact: 'Impatto sulla riservatezza',
    integrityImpact: "Impatto sull'integrità",
    availabilityImpact: 'Impatto sulla disponibilità',
    networkInternet: 'Rete Internet',
    adjacentNetwork: 'Rete Adiacente',
    localAccess: 'Accesso Locale',
    complexityLow: 'Bassa',
    complexityHigh: 'Alta',
    privNone: 'Nessuna',
    privLow: 'Privilegi bassi',
    privHigh: 'Privilegi elevati',
    userInteractionNone: 'Non richiesta',
    userInteractionRequired: 'Richiesta',
    impactFull: 'Completo',
    impactPartial: 'Parziale',
    impactNone: 'Nessuno',
    scoreCvss: 'Punteggio CVSS v3.1',
    detailsBtn: 'Dettagli',
    launchBtn: 'Avvia',
    relaunchBtn: 'Riavvia',
    analyzingLabel2: 'Analisi...',
    remediationRecommendedDelay: 'Tempistica consigliata',
    remediationMaxWindow: 'Finestra massima di correzione',
    remediationImpact: 'Impatto',
    remediationHighImpact: 'ALTO',
    remediationRestartRequired: 'Riavvio del servizio richiesto',
    remediationStepsTitle: 'Passi di remediation dettagliati',
    step1Title: 'Backup e preparazione',
    step1Desc: 'Prima di qualsiasi modifica, eseguire un backup completo del sistema.',
    step1Li1: 'Verificare lo spazio su disco disponibile',
    step1Li2: 'Documentare la configurazione corrente',
    step1Li3: 'Informare i team interessati',
    step2Title: 'Aggiornamento di Apache Struts',
    step2Desc: "Scaricare e installare l'ultima versione sicura di Apache Struts.",
    step2Warning: "Attenzione: Verificare la compatibilità con la propria applicazione prima dell'aggiornamento",
    step3Title: 'Configurazione WAF',
    step3Desc: 'Implementare regole WAF per bloccare i tentativi di exploit OGNL.',
    step4Title: 'Hardening della configurazione',
    step4Desc: 'Rafforzare la configurazione di Struts per prevenire future vulnerabilità.',
    step5Title: 'Riavvio e validazione',
    step5Desc: 'Riavviare i servizi e verificare che la correzione sia efficace.',
    step5Li1: "Verificare che l'applicazione si avvii correttamente",
    step5Li2: 'Testare le funzionalità critiche',
    step5Li3: 'Rilanciare una scansione di vulnerabilità per confermare',
    step6Title: 'Monitoraggio e sorveglianza',
    step6Desc: 'Implementare un monitoraggio continuo per rilevare i tentativi di sfruttamento.',
    step6Li1: 'Configurare avvisi IDS/IPS per i pattern di attacco Struts',
    step6Li2: 'Attivare la registrazione dettagliata delle richieste HTTP',
    step6Li3: 'Pianificare scansioni di vulnerabilità regolari (settimanali)',
    step6Li4: 'Iscriversi ai bollettini di sicurezza di Apache Struts',
    workaroundTitle: 'Soluzione temporanea (se la patch non è possibile)',
    workaroundDesc: "Se l'aggiornamento immediato non è possibile, applicare queste misure di mitigazione:",
    workaround1: "Bloccare l'accesso esterno al servizio (firewall/ACL)",
    workaround2: 'Implementare un reverse proxy con filtraggio degli header Content-Type',
    workaround3: 'Disabilitare gli endpoint REST non essenziali',
    workaround4: 'Attivare la modalità strict del parser multipart',
    attackDetails: "Dettagli dell'Attacco",
    targetInfo: 'Target',
    systemInfoTitle: 'Informazioni di Sistema',
    hostnameLabel: 'Nome host',
    architectureLabel: 'Architettura',
    ipLabel: 'Indirizzo IP',
    initialUserLabel: 'Utente iniziale',
    privilegesObtained: 'Privilegi ottenuti',
    domainLabel: 'Dominio',
    exfiltratedData: 'Dati Esfiltrati ({count})',
    proofCaptures: 'Acquisizioni di Prova ({count})',
    aiResponsesCount: '{count} risposta/e IA',
    questionLabel: 'Domanda:',
    discoveredField: 'Scoperto',
    aiExecAlert: 'Esecuzione delle raccomandazioni IA su {host}:{port}\n\nTest di penetrazione automatizzato avviato\nScansione vulnerabilità in corso\nVerifica vettori di attacco\n\nRisultati disponibili tra pochi minuti...',
    exploitSearchAlert: 'Ricerca e test di exploit su {host}:{port}\n\nConnessione a Metasploit Framework\nScansione moduli applicabili\nTest automatizzato degli exploit\n\n3 exploit trovati, test in corso...',
    exploitGenAlert: 'Generazione ed esecuzione exploit IA su {host}:{port}\n\nAnalisi della vulnerabilità\nGenerazione del payload personalizzato\nEsecuzione sul target\n\nRisultato: Sfruttamento riuscito!\nSessione stabilita.',
    screenshotInitialConn: 'Connessione iniziale',
    screenshotInitialConnDesc: 'Stabilimento della connessione reverse shell',
    screenshotSysInfo: 'Informazioni di sistema',
    screenshotSysInfoDesc: 'Recupero delle informazioni del target',
    screenshotFileAccess: 'Accesso ai file',
    screenshotFileAccessDesc: 'Prova di accesso al file system',
    attackComplexity: 'Complessità di attacco',
    attackVector: 'Vettore di attacco',
    cvssMetrics: 'Metriche CVSS',
    exportCsv: 'Esporta CSV',
    exportJson: 'Esporta JSON',
    host: 'Host',
    immediateFix: 'Correzione immediata',
    noCVE: 'Nessun CVE',
    port: 'Porta',
    privilegesRequired: 'Privilegi richiesti',
    remediation: 'Rimedio',
    remediationSummary: 'Riepilogo rimedio',
    service: 'Servizio',
    sortByCvss: 'Ordina per CVSS',
    sortBySeverity: 'Ordina per gravità',
    userInteraction: 'Interazione utente',
    screenshotPrivEsc: 'Escalation di privilegi',
    screenshotPrivEscDesc: 'Tentativo di escalation di privilegi',
  },

  // Reports
  reports: {
    title: 'Report',
    newReport: 'Nuovo report',
    generateReport: 'Genera report',
    downloadReport: 'Scarica report',
    reportType: 'Tipo di report',
    settings: 'Impostazioni',
    branding: 'Branding',
    types: {
      executive: 'Report esecutivo',
      technical: 'Report tecnico',
      compliance: 'Report di conformità',
      full: 'Report completo',
      vulnerability_list: 'Report vulnerabilità',
      redteam: 'Report Red Team',
      retest: 'Report di retest',
      multi_campaign: 'Report multi-campagna',
      active_directory: 'Report Active Directory',
      data_leak: 'Report fughe di dati',
      attack_surface: 'Report superficie di attacco'
    },
    format: 'Formato',
    formats: {
      pdf: 'PDF',
      html: 'HTML',
      json: 'JSON',
      csv: 'CSV',
      docx: 'Word (DOCX)',
      xml: 'XML',
      jira: 'Jira',
      servicenow: 'ServiceNow',
      glpi: 'GLPI',
      pptx: 'PowerPoint (PPTX)',
      txt: 'Testo (TXT)',
      xlsx: 'Excel (XLSX)'
    },
    includeEvidence: 'Includi prove',
    includeRemediation: 'Includi raccomandazioni',
    generatedAt: 'Generato il',
    generatedBy: 'Generato da',
    noReports: 'Nessun report',

    // Export modal
    export: {
      title: 'Esportazione',
      processing: 'Esportazione in corso...',
      generating: 'Generazione del file',
      takingLong: 'Questa operazione richiede più tempo del previsto.',
      canWaitOrEmail: 'Puoi attendere o chiudere questa finestra e ti invieremo un link via e-mail.',
      sendByEmail: 'Ricevi via e-mail',
      continueWaiting: 'Puoi anche continuare ad attendere, il download inizierà automaticamente.',
      emailSent: 'E-mail inviata!',
      emailSentDesc: 'Riceverai il link per il download via e-mail tra pochi istanti.',
      wordLocked: 'Disponibile per i piani Enterprise e superiori'
    },
    typeDescriptions: {
      executive: 'Sintesi strategica per il COMEX con indicatori chiave e raccomandazioni prioritarie',
      technical: 'Analisi completa delle vulnerabilità con dettagli tecnici e remediation',
      vulnerability_list: 'Esportazione strutturata per Jira, ServiceNow, GLPI',
      redteam: 'Scenario di attacco narrativo con mappatura MITRE ATT&CK',
      retest: 'Confronto prima/dopo la correzione',
      multi_campaign: 'Vista consolidata di più scansioni',
      active_directory: 'Audit AD, privilegi, GPO, deleghe',
      data_leak: 'Rilevamento di dati esposti e credenziali',
      attack_surface: 'Cartografia dell\'esposizione esterna',
    },
    aiGenerated: 'Report IA',
    generated: {
      title: 'Report Generati da IA',
      subtitle: 'Report professionali generati da LLM',
      create: 'Crea un report',
      createNew: 'Nuovo report IA',
      selectType: 'Tipo di report',
      selectScan: 'Seleziona una scansione',
      selectWorkspace: 'Seleziona un workspace',
      selectFormat: 'Formato di output',
      generating: 'Generazione in corso...',
      regenerate: 'Rigenera',
      regenerateSection: 'Rigenera questa sezione',
      export: 'Esporta',
      download: 'Scarica',
      delete: 'Elimina',
      confirmDelete: 'Sei sicuro di voler eliminare questo report?',
      status: {
        pending: 'In attesa',
        queued: 'In coda',
        generating: 'In generazione',
        completed: 'Completato',
        failed: 'Fallito',
        cancelled: 'Annullato',
      },
      sections: {
        executive_summary: 'Sommario esecutivo',
        key_findings: 'Conclusioni principali',
        recommendations: 'Raccomandazioni',
        technical_details: 'Dettagli tecnici',
        vulnerability_analysis: 'Analisi delle vulnerabilità',
        risk_assessment: 'Valutazione dei rischi',
        remediation_plan: 'Piano di remediation',
        attack_narrative: 'Narrativa dell\'attacco',
        mitre_mapping: 'Mappatura MITRE ATT&CK',
        timeline: 'Cronologia',
        appendix: 'Appendici',
      },
      quality: {
        score: 'Punteggio di qualità',
        excellent: 'Eccellente',
        good: 'Buono',
        average: 'Medio',
        poor: 'Scarso',
      },
      noReports: 'Nessun report generato',
      noReportsDesc: 'Crea il tuo primo report IA per iniziare',
      totalReports: 'Totale report',
      completedReports: 'Report completati',
      averageQuality: 'Qualità media',
      lastGenerated: 'Ultimo report',
    },
    placeholders: {
      footerText: 'Es: Documento riservato - Non distribuire',
      logoUrl: 'https://azienda.it/logo.png',
      contactEmail: 'contatto@azienda.it',
      sectionTitle: 'Titolo della sezione...',
      sectionDescription: 'Descrizione (opzionale)...',
      contentTemplate: 'Inserisci il modello di contenuto (Markdown supportato)...\n\nVariabili disponibili:\n{{scan.target}} - Target della scansione\n{{scan.date}} - Data della scansione\n{{vulnerabilities.count}} - Numero di vulnerabilità\n{{vulnerabilities.critical}} - Vulnerabilità critiche',
    },
    config: {
      title: 'Configurazione',
      subtitle: 'Configura i tipi di report disponibili e personalizza il loro contenuto',
      settingsTitle: 'Parametri dei report',
      brandingTitle: 'Immagine dei report',
      defaultLanguage: 'Lingua predefinita',
      confidentialityLevel: 'Livello di riservatezza',
      includeOptions: 'Opzioni di inclusione',
      includeLogo: 'Includi il logo',
      includeTableOfContents: 'Includi il sommario',
      includeAppendices: 'Includi le appendici',
      includeMethodology: 'Includi la metodologia',
      footerTextLabel: 'Testo del piè di pagina',
      logoUrlLabel: 'URL del logo',
      primaryColor: 'Colore principale',
      secondaryColor: 'Colore secondario',
      companyInfo: 'Informazioni aziendali (per i report)',
      companyName: "Nome dell'azienda",
      address: 'Indirizzo',
      contactEmail: 'E-mail di contatto',
      phone: 'Telefono',
      website: 'Sito web',
      sectionsTitle: 'Sezioni del report',
      addSection: 'Aggiungi una sezione',
      noTypeSelected: 'Nessun tipo selezionato',
      noTypeSelectedHint: 'Clicca su un tipo di report nell\'elenco per visualizzare e personalizzare le sue sezioni',
      sectionRequired: 'Sezione obbligatoria',
      sectionActive: 'Attivo',
      requiredBadge: 'Obbligatorio',
      contentTemplateLabel: 'Modello di contenuto (Markdown supportato)',
      clickToAddTemplate: 'Clicca per aggiungere un modello di contenuto...',
      markdownHint: 'Usa Markdown per la formattazione. Variabili: {{variable}}',
      noReportTypes: 'Nessun tipo di report disponibile',
      loadError: 'Errore durante il caricamento del report',
      loadingReport: 'Caricamento del report...',
      loadDataError: 'Errore durante il caricamento dei dati',
      loadSectionsError: 'Errore durante il caricamento delle sezioni',
      deleteError: "Errore durante l'eliminazione",
      reorderError: 'Errore durante il riordinamento',
      addError: "Errore durante l'aggiunta",
      updateError: "Errore durante l'aggiornamento",
      saveError: 'Errore durante il salvataggio',
      downloadError: 'Errore durante il download',
      generateError: 'Errore durante la generazione del report',
      regenerateError: 'Errore durante la rigenerazione',
      noGeneratedFile: 'Nessun file generato',
      noScansAvailable: 'Nessuna scansione completata disponibile per generare i report. Si prega di eseguire prima una scansione.',
      noVulnsDetected: 'Nessuna vulnerabilità rilevata nelle scansioni. Il piano di remediation sarà vuoto.',
      loadingPentests: 'Caricamento dei pentest...',
      noScanAvailable: '-- Nessuna scansione disponibile --',
      networkError: 'Errore di rete. Verifica la connessione.',
    },
  },

  // Account
  account: {
    title: 'Il mio account',
    profile: 'Profilo',
    security: 'Sicurezza',
    subscription: 'Abbonamento',
    billing: 'Fatturazione',
    credits: 'Crediti',
    notifications: 'Notifiche',
    integrations: 'Integrazioni',
    referral: 'Referral',
    activity: 'Attività',
    contracts: 'Contratti',

    // Profile section
    profileSection: {
      title: 'Informazioni profilo',
      avatar: 'Foto profilo',
      changeAvatar: 'Cambia foto',
      removeAvatar: 'Rimuovi foto',
      firstName: 'Nome',
      lastName: 'Cognome',
      email: 'Email',
      phone: 'Telefono',
      company: 'Azienda',
      position: 'Posizione',
      timezone: 'Fuso orario',
      language: 'Lingua del portale',
      languageDescription: 'Scegli la lingua di visualizzazione dell\'interfaccia',
      updateSuccess: 'Profilo aggiornato con successo',
      updateError: 'Errore durante l\'aggiornamento del profilo',
      languages: {
        fr: 'Francese',
        en: 'Inglese',
        es: 'Spagnolo',
        de: 'Tedesco',
        it: 'Italiano',
        pt: 'Portoghese'
      }
    },

    // Security section
    securitySection: {
      title: 'Sicurezza account',
      changePassword: 'Cambia password',
      currentPassword: 'Password attuale',
      newPassword: 'Nuova password',
      confirmPassword: 'Conferma password',
      passwordRequirements: 'La password deve contenere almeno 8 caratteri',
      twoFactorAuth: 'Autenticazione a due fattori',
      enable2FA: 'Abilita 2FA',
      disable2FA: 'Disabilita 2FA',
      twoFactorEnabled: '2FA abilitata',
      twoFactorDisabled: '2FA disabilitata',
      activeSessions: 'Sessioni attive',
      revokeSession: 'Revoca sessione',
      revokeAllSessions: 'Revoca tutte le sessioni',
      loginHistory: 'Cronologia accessi',
      lastLogin: 'Ultimo accesso',
      apiKeys: 'Chiavi API',
      generateApiKey: 'Genera chiave API',
      deleteApiKey: 'Elimina chiave API',
      passwordsNoMatch: 'Le password non corrispondono',
      passwordChanged: 'Password modificata',
      mfaConfigError: 'Errore di configurazione MFA',
      invalidCode: 'Codice non valido',
      apiKeyGenerated: 'Chiave API generata e copiata',
      confirmApiKeyGenerate: 'Generare una nuova chiave API? Quella precedente verrà invalidata.',
      enterMfaCode: 'Inserisci il tuo codice MFA per disabilitare',
      passwordCopied: 'Password copiata negli appunti',
      generatePasswordFirst: 'Genera una password e verifica il tuo numero di telefono',
      smsSent: 'Password inviata via SMS',
      smsError: 'Errore durante l\'invio dell\'SMS',
      mfaEnabled: '2FA abilitata',
      mfaDisabled: '2FA disabilitata',
      passwordApplied: 'Password applicata ai campi',
    },

    // Subscription section
    subscriptionSection: {
      title: 'Abbonamento',
      currentPlan: 'Piano attuale',
      planDetails: 'Dettagli piano',
      features: 'Funzionalità incluse',
      usage: 'Utilizzo',
      limits: 'Limiti',
      renewalDate: 'Data di rinnovo',
      cancelSubscription: 'Annulla abbonamento',
      upgradePlan: 'Passa a un piano superiore',
      downgradePlan: 'Passa a un piano inferiore',
      plans: {
        free: 'Gratuito',
        pro: 'Pro',
        enterprise: 'Enterprise',
        dedicated: 'Dedicato'
      }
    },

    // Credits section
    creditsSection: {
      title: 'Gestione crediti',
      balance: 'Saldo',
      totalCredits: 'Crediti totali',
      monthlyCredits: 'Crediti mensili',
      packCredits: 'Crediti pacchetto',
      usedThisMonth: 'Usati questo mese',
      remaining: 'Rimanenti',
      buyCredits: 'Acquista crediti',
      creditHistory: 'Cronologia crediti',
      transaction: 'Transazione',
      amount: 'Importo',
      creditCosts: 'Costi operazioni',
      scanCost: 'Costo scansione',
      reportCost: 'Costo report',
      subtitle: 'Gestisci i tuoi crediti, abbonamenti e pacchetti',
      expires: 'Scade il',
      noExpiration: 'Senza scadenza',
      currentPlan: 'Piano attuale',
      statusActive: 'Attivo',
      monthlyPlans: 'Piani mensili',
      free: 'Gratuito',
      perMonth: '/mese',
      creditsPerMonth: 'crediti/mese',
      unlimitedWorkspaces: 'Workspace clienti illimitati',
      externalScans: 'Scansioni esterne',
      internalScans: 'Scansioni interne',
      adScans: 'Scansioni Active Directory',
      select: 'Seleziona',
      creditPacks: 'Pacchetti di crediti',
      credits: 'crediti',
      validity: 'Validità',
      months: 'mesi',
      buy: 'Acquista',
      scans: 'Scansioni',
      leakDetection: 'Rilevamento fughe',
      audits: 'Audit',
      reports: 'Report',
      noTransactions: 'Nessuna transazione',
      transactionHistory: 'Cronologia transazioni',
      refresh: 'Aggiorna',
      date: 'Data',
      type: 'Tipo',
      dashboard: 'Dashboard',
      plansAndPacks: 'Piani e Pacchetti',
      history: 'Cronologia',
      errorOccurred: 'Si è verificato un errore',
      creditsAvailable: 'crediti disponibili',
      confirmPlanChange: 'Conferma cambio piano',
      confirmPurchase: 'Conferma acquisto',
      planActiveImmediately: 'Il piano sarà attivo immediatamente',
      creditsAddedImmediately: 'I crediti verranno aggiunti immediatamente',
      cancel: 'Annulla',
      processing: 'Elaborazione...',
      confirm: 'Conferma',
      planSubscribed: 'Abbonamento al piano {plan} riuscito',
      packPurchased: 'Acquisto del pacchetto {pack} riuscito',
      statusPremium: 'PREMIUM',
      statusExhausted: 'ESAURITO',
      statusCritical: 'CRITICO',
      statusLow: 'BASSO',
      unlimited: 'Illimitato',
      totalBalance: 'Saldo totale disponibile',
      monthly: 'Mensili',
      packs: 'Pacchetti'
    },

    // Notifications section
    notificationsSection: {
      title: 'Preferenze notifiche',
      emailNotifications: 'Notifiche email',
      pushNotifications: 'Notifiche push',
      scanCompleted: 'Scansione completata',
      scanFailed: 'Scansione fallita',
      newVulnerability: 'Nuova vulnerabilità critica',
      reportReady: 'Report pronto',
      securityAlerts: 'Avvisi di sicurezza',
      weeklyDigest: 'Riepilogo settimanale',
      marketingEmails: 'Email marketing'
    },

    // Integrations section
    integrationsSection: {
      title: 'Integrazioni',
      connected: 'Connesso',
      notConnected: 'Non connesso',
      configure: 'Configura',
      disconnect: 'Disconnetti',
      testConnection: 'Testa connessione',
      connectionSuccess: 'Connessione riuscita',
      connectionFailed: 'Connessione fallita',
      availableIntegrations: 'Integrazioni disponibili',
      myIntegrations: 'Le mie integrazioni'
    },

    // Referral section
    referralSection: {
      title: 'Programma referral',
      referralLink: 'Link di referral',
      copyLink: 'Copia link',
      shareLink: 'Condividi link',
      inviteFriends: 'Invita amici',
      referralStats: 'Statistiche referral',
      totalReferrals: 'Referral totali',
      pendingReferrals: 'Referral in attesa',
      completedReferrals: 'Referral completati',
      earnedCredits: 'Crediti guadagnati',
      inviteByEmail: 'Invita via email',
      contacts: 'Contatti invitati',
      rewards: 'Premi',
      leaderboard: 'Classifica',
      inviteContact: 'Invita un contatto',
      shareDescription: 'Condividi questo link per invitare nuovi utenti',
      loading: 'Caricamento...',
      yourLevel: 'Il tuo livello',
      nextLevel: 'Prossimo livello',
      creditsEarned: 'Crediti guadagnati',
      conversionFunnel: 'Funnel di conversione',
      invited: 'Invitati',
      clicked: 'Cliccati',
      signedUp: 'Registrati',
      converted: 'Convertiti',
      clickRate: 'Tasso di clic',
      conversionRate: 'Tasso di conversione',
      perClick: 'Per clic',
      perSignup: 'Per registrazione',
      perProConversion: 'Per conversione Pro',
      noContacts: 'Nessun contatto invitato',
      inviteFirstContact: 'Invita il tuo primo contatto',
      contact: 'Contatto',
      creditsGenerated: 'Crediti generati',
      topReferrers: 'Top Referrer',
      rank: 'Posizione',
      user: 'Utente',
      tier: 'Livello',
      referrals: 'Referral',
      conversions: 'Conversioni',
      value: 'Valore',
      you: '(tu)',
      firstName: 'Nome',
      lastName: 'Cognome',
      company: 'Azienda',
      sendInvitation: 'Invia invito',
      referralLinkCopied: 'Link di referral copiato!',
      invitationSent: 'Invito inviato con successo!',
      contactRemoved: 'Contatto rimosso',
      deleteContactConfirm: 'Eliminare questo contatto?',
      resendInvitation: 'Reinvia invito',
      statusInvited: 'Invitato',
      statusClicked: 'Cliccato',
      statusSignedUp: 'Registrato',
      statusConverted: 'Convertito',
      statusChurned: 'Abbandonato',
      remainingToNextTier: 'rimanenti',
      errorSending: 'Errore durante l\'invio',
      errorResending: 'Errore durante il reinvio',
      errorDeleting: 'Errore durante l\'eliminazione',
      planSubscribed: 'Abbonamento al piano {plan} riuscito',
      packPurchased: 'Acquisto del pacchetto {pack} riuscito'
    },

    // Save buttons
    // Avatar section
    avatarSection: {
      invalidType: 'Seleziona un\'immagine',
      tooLarge: 'L\'immagine non deve superare 2 MB',
      updateSuccess: 'Avatar aggiornato',
      updateError: 'Errore durante l\'aggiornamento dell\'avatar',
      readError: 'Errore durante la lettura del file'
    },

    // Company section
    companySection: {
      title: 'Informazioni aziendali',
      logo: 'Logo aziendale',
      name: 'Nome azienda',
      legalForm: 'Forma giuridica',
      capital: 'Capitale sociale',
      address: 'Indirizzo',
      city: 'Città',
      postalCode: 'Codice postale',
      country: 'Paese',
      timezone: 'Fuso orario (per le scansioni)',
      legalRep: 'Rappresentante legale',
      fullName: 'Nome completo',
      updateSuccess: 'Informazioni aziendali aggiornate',
      updateError: 'Errore durante il salvataggio'
    },

    // Team section
    teamSection: {
      confirmRemove: 'Sei sicuro di voler rimuovere questo membro?',
      memberRemoved: 'Membro rimosso'
    },

    // Logo section
    logoSection: {
      updated: 'Logo aggiornato',
      updatedAV: 'Logo aggiornato - Scansione antivirus OK',
      updateError: 'Errore durante l\'aggiornamento del logo',
      deleted: 'Logo eliminato',
      deleteError: 'Errore durante l\'eliminazione del logo',
    },

    configuration: 'Configurazione',
    team: 'Team',
    users: 'Utenti',
    help: 'Aiuto',
    history: 'Cronologia',
    version: 'Versione',
    support: 'Supporto',
    reportTypes: 'Tipi di report',
    loadError: 'Errore durante il caricamento dell\'account',
    saveAll: 'Salva tutto',
    saveProfile: 'Salva profilo',
    saveCompany: 'Salva azienda'
  },

  // Settings
  settings: {
    title: 'Impostazioni',
    general: 'Generali',
    tools: 'Strumenti',
    network: 'Rete',
    advanced: 'Avanzate',

    generalSection: {
      title: 'Impostazioni generali',
      defaultScanType: 'Tipo di scansione predefinito',
      defaultReportFormat: 'Formato report predefinito',
      autoSaveReports: 'Salvataggio automatico report',
      enableNotifications: 'Abilita notifiche',
      darkMode: 'Modalità scura',
      compactView: 'Vista compatta'
    },

    toolsSection: {
      title: 'Configurazione strumenti',
      enabledTools: 'Strumenti abilitati',
      toolSettings: 'Impostazioni strumenti',
      timeout: 'Timeout',
      threads: 'Numero di thread',
      verbosity: 'Livello di dettaglio'
    },

    networkSection: {
      title: 'Configurazione rete',
      proxySettings: 'Impostazioni proxy',
      vpnSettings: 'Impostazioni VPN',
      dnsSettings: 'Impostazioni DNS',
      useProxy: 'Usa proxy',
      proxyHost: 'Host proxy',
      proxyPort: 'Porta proxy'
    },

    // Server status
    uptime: 'Tempo di attività'
  },

  // Admin
  admin: {
    title: 'Amministrazione',
    users: 'Utenti',
    companies: 'Aziende',
    system: 'Sistema',
    logs: 'Log',
    maintenance: 'Manutenzione',

    usersSection: {
      title: 'Gestione utenti',
      addUser: 'Aggiungi utente',
      editUser: 'Modifica utente',
      deleteUser: 'Elimina utente',
      activateUser: 'Attiva utente',
      deactivateUser: 'Disattiva utente',
      resetPassword: 'Reimposta password',
      role: 'Ruolo',
      roles: {
        admin: 'Amministratore',
        user: 'Utente',
        viewer: 'Osservatore'
      },
      lastLogin: 'Ultimo accesso',
      createdAt: 'Creato il',
      noUsers: 'Nessun utente'
    },

    systemSection: {
      title: 'Sistema',
      systemInfo: 'Informazioni sistema',
      version: 'Versione',
      uptime: 'Tempo di attività',
      restart: 'Riavvia',
      backup: 'Backup',
      restore: 'Ripristina',
      update: 'Aggiorna'
    }
  },

  // Errors
  errors: {
    generic: 'Si è verificato un errore',
    notFound: 'Pagina non trovata',
    unauthorized: 'Accesso non autorizzato',
    forbidden: 'Accesso vietato',
    serverError: 'Errore del server',
    networkError: 'Errore di rete',
    timeout: 'Timeout scaduto',
    validation: 'Errore di validazione',
    invalidEmail: 'Email non valida',
    invalidPassword: 'Password non valida',
    passwordMismatch: 'Le password non corrispondono',
    requiredField: 'Questo campo è richiesto',
    minLength: 'Minimo {min} caratteri richiesti',
    maxLength: 'Massimo {max} caratteri consentiti',
    fillAllFields: 'Per favore compila tutti i campi richiesti',
    emailAlreadyUsed: 'Questa email è già in uso',
    companyAlreadyRegistered: 'Questa azienda è già registrata',
    registrationError: 'Errore durante la registrazione',
    genericError: 'Si è verificato un errore imprevisto',
    disposableEmailNotAllowed: 'Le email temporanee non sono consentite',
    personalEmailNotAllowed: 'L\'email {domain} non è consentita. Usa un\'email professionale.',
    invalidResetLink: 'Questo link di reimpostazione non è valido o è scaduto. Richiedi un nuovo link.',
    resetLinkExpired: 'Questo link di reimpostazione è scaduto. Richiedi un nuovo link.',
    resetPasswordFailed: 'Reimpostazione password non riuscita. Riprova.',
    passwordCriteriaNotMet: 'La password non soddisfa tutti i criteri richiesti.',
    backendMessages: {
      'Workspace not found': 'Workspace non trovato',
      'Invalid signature token': 'Token di firma non valido',
      'Contract already signed': 'Contratto già firmato',
      'Contract already pending signature. Cancel existing request first.': 'Contratto già in attesa di firma. Annulla prima la richiesta esistente.',
      'Contract not yet signed': 'Contratto non ancora firmato',
      'Signed contract file not found': 'File del contratto firmato non trovato',
      'Contract file not found on disk': 'File del contratto non trovato sul disco',
      'Contract already signed, cannot cancel': 'Contratto già firmato, impossibile annullare',
      'No pending signature request to cancel': 'Nessuna richiesta di firma in attesa da annullare',
      'User not found': 'Utente non trovato',
      'Invalid credentials': 'Credenziali non valide',
      'Access denied': 'Accesso negato',
      'Permission denied': 'Permesso negato',
      'Not found': 'Non trovato',
      'Bad request': 'Richiesta non valida',
      'Internal server error': 'Errore interno del server',
      'Service unavailable': 'Servizio non disponibile'
    },
    verificationFailed: 'La verifica dell\'email non è riuscita. Il link potrebbe essere scaduto o non valido.',
    invalidVerificationLink: 'Questo link di verifica non è valido o è scaduto. Richiedi un nuovo link.',
    rateLimitExceeded: 'Troppi tentativi. Riprova tra qualche minuto.',
    rateLimitEmail: 'Attendi qualche minuto prima di reinviare un\'email di verifica.',
    '401': {
      title: 'Non Autorizzato',
      subtitle: 'Oops! Devi accedere',
      description: 'La tua sessione è scaduta o non sei autenticato. Accedi per visualizzare questa pagina.',
      redirectText: 'Reindirizzamento al login'
    },
    '403': {
      title: 'Accesso Negato',
      subtitle: 'Oops! Accesso vietato',
      description: 'Non hai i permessi necessari per accedere a questa risorsa.',
      redirectText: 'Reindirizzamento alla dashboard'
    },
    '404': {
      title: 'Pagina Non Trovata',
      subtitle: 'Oops! Pagina non trovata',
      description: 'La pagina che stai cercando non esiste o è stata spostata.',
      redirectText: 'Reindirizzamento alla dashboard'
    },
    '500': {
      title: 'Errore Server',
      subtitle: 'Oops! Si è verificato un errore',
      description: 'Il server ha riscontrato un errore. Riprova tra qualche istante.',
      redirectText: 'Reindirizzamento alla dashboard'
    },
    '503': {
      title: 'Servizio Non Disponibile',
      subtitle: 'Oops! Servizio temporaneamente non disponibile',
      description: 'Il servizio è temporaneamente non disponibile per manutenzione. Riprova tra qualche istante.',
      redirectText: 'Reindirizzamento alla dashboard'
    },
    backToDashboard: 'Torna alla Dashboard',
    retry: 'Riprova',
    supportContact: 'Se il problema persiste, contatta il supporto tecnico.',
    redirectingIn: 'tra',
    seconds: 'secondi',
    error: 'Errore',
    companyRequired: 'Devi appartenere a un\'azienda per eseguire questa azione',
    selectRequired: 'Effettua una selezione',
    sessionExpired: 'Sessione scaduta. Accedi di nuovo.'
  },

  // Success messages
  success: {
    saved: 'Salvato con successo',
    deleted: 'Eliminato con successo',
    updated: 'Aggiornato con successo',
    created: 'Creato con successo',
    copied: 'Copiato negli appunti',
    sent: 'Inviato con successo',
    uploaded: 'Caricato con successo'
  },

  // Time
  time: {
    now: 'Ora',
    seconds: 'secondi',
    minutes: 'minuti',
    hours: 'ore',
    days: 'giorni',
    weeks: 'settimane',
    months: 'mesi',
    years: 'anni',
    ago: 'fa',
    in: 'tra'
  },

  // Credentials
  credentials: {
    title: 'Credenziali',
    username: 'Nome utente',
    password: 'Password',
    hash: 'Hash',
    domain: 'Dominio',
    source: 'Fonte',
    foundAt: 'Trovato il',
    noCredentials: 'Nessuna credenziale trovata',
    export: 'Esporta credenziali',
    addNumbers: 'Aggiungi numeri',
    addSpecialChars: 'Caratteri speciali',
    noPasswordSave: 'Nessuna password da salvare',
    saveDictionaryError: 'Errore durante il salvataggio del dizionario',
    loadDictionariesError: 'Errore durante il caricamento dei dizionari',
    loadDictionaryError: 'Errore durante il caricamento del dizionario',
    deleteError: 'Errore durante l\'eliminazione',
    downloadError: 'Errore durante il download',
    searchError: 'Ricerca non riuscita',
    validationError: 'Errore durante la validazione',
    noCredentialExport: 'Nessuna credenziale da esportare',
    noPasswordExport: 'Nessuna password da esportare',
    decryptError: 'Errore durante la decifratura',
    noDictionarySaved: 'Nessun dizionario salvato',
    noWorkspace: '-- Nessun workspace --',
    noResult: 'Nessun risultato',
    noResultMatch: 'Nessuna credenziale corrisponde',
    noPasswordAvailable: 'Nessuna password disponibile'
  },

  // Sessions
  sessions: {
    title: 'Sessioni',
    sessionDetails: 'Dettagli sessione',
    activeSession: 'Sessione attiva',
    closedSession: 'Sessione chiusa',
    sessionType: 'Tipo di sessione',
    target: 'Obiettivo',
    startedAt: 'Iniziato alle',
    endedAt: 'Terminato alle',
    duration: 'Durata',
    commands: 'Comandi',
    noSessions: 'Nessuna sessione',
    closeSession: 'Chiudi sessione',
    quickActions: 'Azioni rapide',
    quickCommands: 'Comandi rapidi',
    defaultSessionType: 'Terminale',
    sessionLabel: 'Sessione',
    pageTitle: 'Sessioni di Exploitation',
    pageDescription: 'Gestione delle sessioni di exploitation e accessi compromessi',
    manualExploit: 'Manuale',
    platform: 'Piattaforma',
    platformUnknown: 'Sconosciuta',
    exploitUsed: 'Exploit utilizzato',
    commandsExecuted: 'Comandi eseguiti',
    interactiveShell: 'Terminale interattivo',
    status: {
      active: 'Attiva',
      inactive: 'Inattiva',
      closed: 'Chiusa',
      stale: 'Da riavviare',
      idle: 'Inattiva',
      error: 'Errore',
      unknown: 'Sconosciuta',
      queued: 'In coda',
      running: 'In corso',
      pending: 'In attesa',
      completed: 'Completata',
      failed: 'Fallita'
    },
    badges: {
      root: 'ROOT',
      persistent: 'PERSISTENTE'
    },
    persistence: {
      installed: 'Installata',
      notInstalled: 'Non installata'
    },
    quickPrompts: {
      help: 'Aiuto',
      privesc: 'Privesc',
      persistence: 'Persistenza',
      lateral: 'Movimento laterale',
      pocAuto: 'PoC auto',
      aptModules: 'Moduli APT'
    },
    errors: {
      connectionError: 'Errore di connessione al server',
      loadingError: 'Errore durante il caricamento delle sessioni',
      actionError: 'Errore durante l\'esecuzione dell\'azione',
      serverError: 'Errore interno del server',
      serviceUnavailable: 'Servizio temporaneamente non disponibile',
      loadFailed: 'Caricamento non riuscito',
      screenshotFailed: 'Screenshot non riuscito',
      privescFailed: 'Escalation privilegi non riuscita',
      persistenceFailed: 'Installazione persistenza non riuscita',
      aptExecutionFailed: 'Esecuzione modulo APT non riuscita'
    },
    actions: {
      screenshotSuccess: 'Screenshot effettuato',
      privescSuccess: 'Escalation privilegi riuscita',
      privescCompleted: 'Tentativo di escalation completato',
      persistenceSuccess: 'Meccanismo di persistenza installato',
      persistenceCompleted: 'Installazione completata'
    },
    privilegeLevel: 'Livello di privilegio',
    lastActivity: 'Ultima attività',
    screenshot: 'Screenshot',
    privilegeEscalation: 'Escalation privilegi',
    downloadLogs: 'Scarica log',
    migrationRecommended: 'Migrazione raccomandata',
    connected: 'Connesso',
    connecting: 'Connessione...',
    confirmInstallPersistence: 'Installare un meccanismo di persistenza?',
    confirmCloseSession: 'Sei sicuro di voler chiudere questa sessione?'
  },

  // Attack
  attack: {
    title: 'Centro di Attacco',
    description: 'Strumenti di attacco avanzati e orchestratore dinamico',
    selectTarget: 'Seleziona obiettivo',
    selectTechnique: 'Seleziona tecnica',
    launchAttack: 'Lancia attacco',
    attackInProgress: 'Attacco in corso',
    attackCompleted: 'Attacco completato',
    attackFailed: 'Attacco fallito',
    techniques: 'Tecniche',
    payloads: 'Payload',
    results: 'Risultati',
    dynamicOrchestrator: 'Orchestratore Dinamico',
    attackGraph: 'Grafo di Attacco',
    attackBuilder: 'Costruttore di Attacco',
    launchChain: 'Avvia la catena',
    continueChain: 'Riprendi',
    restartAll: 'Riavvia tutto',
    executing: 'Esecuzione...',
    aiSuggestions: 'Suggerimenti IA',
    ready: 'Pronto',
    inProgress: 'In corso...'
  },
  // Active Directory
  ad: {
    title: 'Active Directory',
    description: 'Strumenti di attacco AD con assistenza AI LLM e PoC automatizzato',
    domain: 'Dominio',
    dcIp: 'IP del Domain Controller',
    username: 'Nome utente',
    password: 'Password',
    ntlmHash: 'Hash NTLM (opzionale)',
    dcConfiguration: 'Configurazione Domain Controller',
    attacks: 'Attacchi AD',
    ldapPentest: 'Pentest LDAP/LDAPS',
    searchPlaceholder: 'Cerca un attacco, uno strumento...',
    allCategories: 'Tutte le categorie',
    attackCategories: 'Categorie di Attacchi',
    targetResults: 'Obiettivo / Risultati',
    noDataMessage: 'Seleziona un attacco per iniziare',
    noDataHint: 'Oppure usa Auto PoC per una catena di attacchi',
    readyToStart: 'Pronto per iniziare',
    stats: {
      attacks: 'Attacchi',
      successful: 'Riusciti',
      failed: 'Falliti',
      credentials: 'Credenziali',
      users: 'Utenti',
      paths: 'Percorsi',
    },
    attackWizard: 'Assistente di Attacchi AD',
    backToAD: 'Torna alla pagina AD',
    auditRunning: 'Audit AD in corso',
    auditRunningDesc: 'Analisi di Active Directory {domain}... La pagina si aggiorna automaticamente.',
    auditFailed: 'Audit fallito',
    globalRiskScore: 'Punteggio di rischio globale',
    scoresByCategory: 'Punteggi per categoria',
    noScoresCalculated: 'Nessun punteggio calcolato',
    auditInfo: "Informazioni dell'audit",
    criticalIndicatorsPriority: 'Indicatori critici da trattare con priorità',
    riskScoreCritical: 'Il dominio presenta vulnerabilità critiche che richiedono un\'azione immediata.',
    riskScoreHigh: 'Sono stati identificati rischi significativi nel dominio Active Directory.',
    riskScoreMedium: 'Alcuni aspetti da migliorare con priorità media.',
    riskScoreLow: 'Il dominio presenta un livello di rischio basso. Mantieni le buone pratiche.',
    objectsAffected: '{count} oggetto/i colpito/i',
    recommendedSolution: 'Soluzione raccomandata',
    noActionRequired: 'Nessuna azione richiesta',
    noRiskIndicators: 'Il dominio non presenta alcun indicatore di rischio.',
    immediateActions: 'Azioni immediate',
    recommendedImprovements: 'Miglioramenti raccomandati',
    prioritizedActionPlan: 'Piano d\'azione prioritizzato basato su {count} indicatori rilevati. Le azioni immediate (< 30gg) devono essere trattate prima della generazione dei report AD.',
    generateAIAnalysis: "Genera l'analisi IA",
    generateAIAnalysisDesc: "L'IA analizzerà i {count} indicatori AD per:",
    generatingAI: 'Analisi in corso…',
    generatingAIDesc: "L'IA analizza i {count} indicatore/i AD e genera la guida all'attacco",
    generatingAITime: 'Questo può richiedere 2-4 minuti in base al carico del server GPU',
    analysisGenerated: 'Analisi generata — {domain} · Punteggio {score}/100 ({risk})',
    indicatorsAnalyzed: '{count} indicatore/i analizzato/i',
    regenerate: 'Rigenera',
    rawResponse: 'Risposta grezza',
    analysisError: 'Nota: L\'analisi ha utilizzato un fallback (servizio IA non disponibile).',
    downloadEvidenceReport: 'Scarica il report delle prove (.txt)',
    noIndicatorsForFilter: 'Nessun indicatore di gravità {filter}.',
    noRiskIndicatorsDetected: 'Nessun indicatore di rischio rilevato.',
    statsDomainAdmins: 'Admin di dominio',
    statsMaxPrivAccounts: 'Account con massimi privilegi',
    statsKerberoastable: 'Kerberoastable',
    statsInventory: 'Inventario',
    statsPrivilegedGroups: 'Gruppi con privilegi',
    statsKerberosDeleg: 'Kerberos e Delega',
    statsOtherAnomalies: 'Altre anomalie',
    statsInterpretation: 'Interpretazione delle statistiche',
    lapsDeployed: 'Distribuito',
    lapsAbsent: 'Assente',
    highIndicators: 'Indicatori High',
    statusDone: '✓ Completato',
    statusRunning: '⟳ In corso',
    statusFailed: '✗ Fallito',
    scanIdLabel: 'ID scansione',
    startedLabel: 'Avviato',
    completedLabel: 'Completato',
    sessionStatusCompleted: 'Completato',
    sessionStatusFailed: 'Fallito',
    sessionStatusStopped: 'Interrotto',
    sessionStatusInitialized: 'Inizializzato',
    sessionTabOverview: 'Panoramica',
    sessionTabSteps: 'Passi',
    sessionTabFindings: 'Findings',
    sessionTabTimeline: 'Cronologia',
    sessionTabAI: 'Analisi IA',
    sessionFindingsDetected: 'Findings rilevati',
    sessionStepsExecuted: 'Passi eseguiti',
    sessionStepsFailed: '{count} falliti, {skipped} ignorati',
    sessionCredentialsFound: 'Credenziali trovate',
    sessionCompromisedAccounts: 'Account compromessi',
    sessionUsersEnumerated: 'Utenti enumerati',
    sessionDuration: 'Durata: {duration}',
    sessionDomainCompromised: 'Dominio compromesso',
    sessionDomainCompromisedDesc: 'Le tecniche eseguite hanno dimostrato la compromissione del dominio Active Directory {domain}. Azione immediata richiesta.',
    sessionAttackPathsFound: 'Percorsi di attacco identificati',
    sessionAttackPathsDesc: 'Sono stati identificati vettori di escalation dei privilegi o movimento laterale nel dominio.',
    sessionCriticalHighFindings: 'Findings critici / alti',
    sessionStepsCompleted: 'Completati',
    sessionStepsSkipped: 'Ignorati',
    sessionNoMatchingSteps: 'Nessun passo corrispondente',
    sessionNoFindingsDetected: 'Nessun finding rilevato',
    sessionNoFindingsForFilter: 'Nessun finding a questo livello di gravità.',
    sessionNoTimelineEvents: 'Nessun evento di cronologia',
    sessionStepsLabel: '{count} passi',
    sessionStepFindings: "Findings del passo",
    sessionRecommendedRemediation: 'Remediation raccomandata',
    sessionAICompromiseGuide: 'Analisi IA — Guida alla compromissione AD',
    sessionAIWillAnalyze: "L'IA analizzerà tutti i findings e i passi di questa sessione per:",
    sessionAIExplainDiscoveries: 'Spiegare le scoperte',
    sessionAIIdentifyPaths: 'Identificare i percorsi di attacco',
    sessionAIStepByStep: 'Guida alla compromissione AD passo per passo',
    sessionAIPriorityRecs: 'Raccomandazioni di remediation prioritarie',
    sessionAILoading: 'Generazione automatica della guida alla compromissione AD',
    sessionAILoadingTime: 'Questo può richiedere 2-4 minuti — elaborazione in background',
    sessionAIAnalysisFor: 'Analisi generata per {domain}',
    sessionAIAnalysisMeta: '{steps} passi · {findings} findings analizzati',
    sessionAIAnalysisCredentials: '· {count} credenziali',
    sessionDownloadEvidence: 'Scarica tutte le prove (.txt)',
    sessionOutputLabel: 'Output',
    sessionStepFindingsLabel: 'Step findings',
    sessionAIAnalysisGenerationTime: 'Generazione via Ollama (sylink/sylink2:27b) — circa 2-4 minuti',
  },

  // Branding (Login/Register pages)
  branding: {
    platformTitle: 'Piattaforma di',
    platformSubtitle: 'Pentest Autonomo',
    platformDescription: 'Analisi di sicurezza basata su IA con sfruttamento automatizzato e report dettagliati.'
  },

  // Features (Login/Register pages)
  features: {
    autonomousAI: {
      title: 'IA Autonoma',
      description: 'Intelligenza artificiale che simula un pentester esperto',
      highlight: 'SYLink LLM On-Premise'
    },
    advancedDetection: {
      title: 'Rilevamento Avanzato',
      description: 'Identificazione automatica delle vulnerabilità critiche',
      highlight: '200K+ CVE'
    },
    completeTests: {
      title: 'Test Completi',
      description: 'Scansioni di rete, web, API e infrastruttura',
      highlight: '100+ Strumenti'
    },
    instantReports: {
      title: 'Report Istantanei',
      description: 'Generazione automatica di report PDF professionali',
      highlight: 'Esporta PDF'
    }
  },

  // Stats (Login/Register pages)
  stats: {
    availability: 'Disponibilità',
    vulnerabilities: 'Vulnerabilità rilevate',
    monitoring: 'Monitoraggio',
    scanTime: 'Tempo medio di scansione'
  },

  // Footer
  footer: {
    title: 'Piattaforma Scanner di Sicurezza',
    subtitle: 'Sistema Autonomo di Penetration Test',
    terms: 'Termini di Utilizzo',
    sales: 'Termini di Vendita',
    privacy: 'Politica sulla Privacy',
    legalNotice: 'Note Legali',
    contact: 'Contatti',
    version: 'Versione',
    licence: 'Licenza n°',
    termsShort: 'Condizioni di utilizzo (CGU)',
    salesShort: 'Condizioni di vendita (CGV)',
    poweredBy: 'Sviluppato da SYLink IA'
  },

  // Enrichment - ABSpider Integration
  enrichment: {
    title: 'Arricchimento & Threat Intelligence',
    subtitle: 'Analisi avanzata di domini e IP con VirusTotal, header di sicurezza, email e geolocalizzazione',
    newScan: 'Nuova scansione',
    quickScan: 'Scansione rapida',
    fullScan: 'Scansione completa',
    viewDetails: 'Vedi dettagli',
    exportReport: 'Esporta rapporto',
    refresh: 'Aggiorna',
    scanTypes: {
      virustotal: 'VirusTotal',
      headers: 'Header di sicurezza',
      security_headers: 'Header di sicurezza',
      email_security: 'Sicurezza email',
      geoip: 'Geolocalizzazione IP',
      reverse_ip: 'Reverse IP',
      full: 'Scansione completa'
    },
    status: {
      pending: 'In attesa',
      running: 'In esecuzione',
      completed: 'Completato',
      failed: 'Fallito',
      cancelled: 'Annullato'
    },
    threatLevels: {
      safe: 'Sicuro',
      low: 'Basso',
      medium: 'Medio',
      high: 'Alto',
      critical: 'Critico'
    },
    form: {
      targetDomain: 'Dominio target',
      targetDomainPlaceholder: 'es: example.com',
      targetIp: 'Indirizzo IP (opzionale)',
      targetIpPlaceholder: 'es: 192.168.1.1',
      scanType: 'Tipo di scansione',
      workspace: 'Workspace (opzionale)',
      startScan: 'Avvia scansione',
      credits: 'Crediti richiesti'
    },
    results: {
      title: 'Risultati',
      noResults: 'Nessun risultato disponibile',
      loading: 'Caricamento risultati...',
      riskScore: 'Punteggio di rischio',
      threatLevel: 'Livello di minaccia',
      scannedAt: 'Scansionato il',
      duration: 'Durata'
    },
    headers: {
      title: 'Analisi header di sicurezza',
      score: 'Punteggio',
      grade: 'Voto',
      present: 'Presenti',
      missing: 'Mancanti',
      recommendations: 'Raccomandazioni',
      headerName: 'Header',
      value: 'Valore',
      status: 'Stato',
      issues: 'Problemi'
    },
    email: {
      title: 'Sicurezza email',
      mxRecords: 'Record MX',
      spf: 'SPF',
      dkim: 'DKIM',
      dmarc: 'DMARC',
      valid: 'Valido',
      invalid: 'Non valido',
      notFound: 'Non trovato',
      policy: 'Politica',
      vulnerabilities: 'Vulnerabilità rilevate',
      recommendations: 'Raccomandazioni'
    },
    geoip: {
      title: 'Geolocalizzazione IP',
      location: 'Posizione',
      country: 'Paese',
      region: 'Regione',
      city: 'Città',
      timezone: 'Fuso orario',
      isp: 'ISP',
      organization: 'Organizzazione',
      isProxy: 'Proxy rilevato',
      isVpn: 'VPN rilevato',
      isTor: 'Tor rilevato'
    },
    virustotal: {
      title: 'Analisi VirusTotal',
      reputation: 'Reputazione',
      malicious: 'Malevolo',
      suspicious: 'Sospetto',
      harmless: 'Innocuo',
      undetected: 'Non rilevato'
    },
    errors: {
      scanFailed: 'Scansione fallita',
      insufficientCredits: 'Crediti insufficienti',
      invalidDomain: 'Dominio non valido',
      networkError: 'Errore di rete',
      invalidIp: 'Indirizzo IP non valido',
      timeout: 'Timeout superato',
      unknownError: 'Errore sconosciuto',
    },
    description: 'Analizza i target con molteplici fonti di intelligence sulla sicurezza',
    target: 'Target',
    type: 'Tipo',
    modules: 'Moduli',
    quickScans: 'Scansioni rapide',
    threatSummary: 'Sommario delle minacce',
    recentScans: 'Scansioni recenti',
    riskScore: 'Punteggio di rischio',
    date: 'Data',
    noScans: 'Nessuna scansione per ora',
    scan: 'Analizza',
    quickResult: 'Risultato della scansione rapida',
    scanDetails: 'Dettagli della scansione',
    statusLabel: 'Stato',
    scanTypes: {
      domain: 'Dominio',
      ip: 'Indirizzo IP',
      url: 'URL',
      ai_scan: 'Scansione IA',
      network_discovery: 'Scoperta rete',
      vulnerability_scan: 'Scansione vulnerabilità',
      full_autonomous: 'Autonomo completo',
      full_auto: 'Autonomo completo',
      full_automation: 'Autonomo completo',
      expert: 'Scansione esperta',
      api_pentest: 'Pentest API',
      iot_scan: 'Scansione IoT',
      ot_scan: 'Scansione OT/SCADA',
      ad_pentest: 'Pentest AD',
      ad_scan: 'Scansione Active Directory',
      ad_recon: 'Ricognizione AD',
      ad_full: 'Scansione AD completa',
      ldap_scan: 'Scansione LDAP',
      kerberos_scan: 'Scansione Kerberos',
      web_scan: 'Scansione Web',
      web: 'Scansione Web',
      quick: 'Rapida',
      quick_scan: 'Scansione rapida',
      discovery: 'Scoperta',
      enumeration: 'Enumerazione',
      vulnerability: 'Vulnerabilità',
      exploitation: 'Sfruttamento',
      passive: 'Passivo',
      aggressive: 'Aggressivo',
      credentials: 'Credenziali',
      recon: 'Ricognizione',
      exploit: 'Sfruttamento',
      bypass: 'Bypass',
      nmap: 'Scansione Nmap',
      nikto: 'Scansione Nikto',
      internal: 'Scansione interna',
      external: 'Scansione esterna',
      network: 'Scansione di rete',
    },
    status: {
      queued: 'In coda',
    },
    email: {
      mechanisms: 'Meccanismi',
      selectors: 'Selettori',
    },
    geoip: {
      coordinates: 'Coordinate',
      network: 'Informazioni di rete',
      asn: 'ASN',
      flags: 'Indicatori di sicurezza',
      isDatacenter: 'Datacenter',
      isHosting: 'Hosting',
    },
    reverseIp: {
      title: 'Ricerca Reverse IP',
      totalDomains: 'Domini trovati',
      domains: 'Elenco dei domini',
      sharedHosting: 'Hosting condiviso',
      hostingProvider: 'Provider di hosting',
      suspiciousDomains: 'Domini sospetti',
      riskScore: 'Punteggio di rischio',
    },
    virustotal: {
      categories: 'Categorie',
      lastAnalysis: 'Ultima analisi',
      permalink: 'Link VirusTotal',
    },
    headers: {
      gradeDescriptions: {
        A: 'Eccellente - Sicurezza ottimale',
        B: 'Buono - Alcuni miglioramenti possibili',
        C: 'Medio - Miglioramenti raccomandati',
        D: 'Basso - Miglioramenti importanti necessari',
        F: 'Insufficiente - Sicurezza critica da migliorare',
      },
    },
    stats: {
      totalScans: 'Totale scansioni',
      completedScans: 'Scansioni completate',
      pendingScans: 'Scansioni in attesa',
      failedScans: 'Scansioni fallite',
      averageScore: 'Punteggio medio',
      criticalThreats: 'Minacce critiche',
      highThreats: 'Minacce alte',
      creditsUsed: 'Crediti usati',
    },
    error: {
      targetRequired: 'Il target è obbligatorio',
      scanFailed: 'Errore durante l\'avvio della scansione',
      quickScanFailed: 'Errore nella scansione rapida',
      loadFailed: 'Errore nel caricamento dei dettagli della scansione',
      deleteFailed: 'Errore durante l\'eliminazione della scansione',
    },
    success: {
      scanStarted: 'Scansione avviata con successo',
      quickScanComplete: 'Scansione rapida completata',
      scanDeleted: 'Scansione eliminata',
    },
    tooltips: {
      virusTotalCredit: "Usa l'API VirusTotal per analizzare la reputazione",
      headersCredit: 'Analizza gli header HTTP di sicurezza',
      emailCredit: 'Verifica SPF, DKIM e DMARC',
      geoipCredit: "Geolocalizza l'indirizzo IP",
      reverseIpCredit: 'Trova i domini ospitati sullo stesso IP',
      fullCredit: 'Esegue tutte le analisi',
    },
    recentIndicators: 'Indicatori recenti',
    aiAnalysis: {
      title: 'Analisi IA',
      executiveSummary: 'Sommario esecutivo',
      keyFindings: 'Punti chiave',
      recommendations: 'Raccomandazioni',
    },
  },

  // Support
  support: {
    title: 'Supporto',
    myTickets: 'I miei ticket di supporto',
    newTicket: 'Nuovo ticket',
    createTicket: 'Crea un ticket',
    ticketDetails: 'Dettagli del ticket',
    ticketNumber: 'Ticket n°{number}',
    backToList: 'Torna alla lista',
    noTickets: 'Nessun ticket di supporto',
    noTicketsDescription: 'Non hai ancora creato alcun ticket di supporto.',
    subject: 'Oggetto',
    subjectPlaceholder: 'Descrivi brevemente il tuo problema',
    description: 'Descrizione',
    descriptionPlaceholder: 'Descrivi il tuo problema in dettaglio...',
    category: 'Categoria',
    priority: 'Priorità',
    status: 'Stato',
    createdAt: 'Creato il',
    updatedAt: 'Aggiornato il',
    lastResponse: 'Ultima risposta',
    messages: 'Messaggi',
    addResponse: 'Aggiungi una risposta',
    responsePlaceholder: 'Scrivi la tua risposta...',
    sendResponse: 'Invia',
    closeTicket: 'Chiudi ticket',
    reopenTicket: 'Riapri ticket',
    attachments: 'Allegati',
    addAttachment: 'Aggiungi un allegato',
    responseFromSupport: 'Risposta del supporto',
    yourResponse: 'La tua risposta',
    statuses: {
      open: 'Aperto',
      pending: 'In attesa',
      in_progress: 'In corso',
      waiting_customer: 'In attesa del cliente',
      waiting_support: 'In attesa del supporto',
      waiting_internal: 'In elaborazione',
      resolved: 'Risolto',
      closed: 'Chiuso'
    },
    priorities: {
      low: 'Bassa',
      medium: 'Media',
      high: 'Alta',
      urgent: 'Urgente',
      critical: 'Critica',
      lowDesc: 'Non urgente, può aspettare',
      mediumDesc: 'Importanza normale',
      highDesc: 'Richiede attenzione rapida',
      urgentDesc: 'Impatto critico sull\'attività',
      priority: 'Priorità'
    },
    message: 'Messaggio',
    categories: {
      technical: 'Problema tecnico',
      billing: 'Fatturazione',
      account: 'Account',
      feature_request: 'Richiesta funzionalità',
      bug_report: 'Segnalazione bug',
      security: 'Sicurezza',
      other: 'Altro',
      technicalDesc: 'Problemi tecnici, errori, malfunzionamenti',
      billingDesc: 'Domande su fatture, pagamenti, abbonamenti',
      feature_requestDesc: 'Suggerimenti di miglioramento o nuove funzionalità',
      bug_reportDesc: 'Segnala un bug o comportamento inatteso',
      accountDesc: 'Gestione account, accesso, permessi',
      securityDesc: 'Domande o preoccupazioni sulla sicurezza',
      otherDesc: 'Altro tipo di richiesta'
    },
    filters: {
      all: 'Tutti',
      open: 'Aperti',
      closed: 'Chiusi',
      myTickets: 'I miei ticket'
    },
    sort: {
      newest: 'Più recenti',
      oldest: 'Più vecchi',
      priority: 'Per priorità',
      status: 'Per stato'
    },
    notifications: {
      newResponse: 'Nuova risposta sul tuo ticket',
      statusChanged: 'Stato del ticket aggiornato',
      ticketClosed: 'Ticket chiuso'
    },
    help: {
      title: 'Hai bisogno di aiuto?',
      description: 'Il nostro team di supporto è disponibile per aiutarti.',
      responseTime: 'Tempo di risposta medio: meno di 24 ore',
      documentation: 'Consulta la documentazione',
      faq: 'Domande frequenti'
    },
    errors: {
      loadFailed: 'Impossibile caricare i ticket',
      loadingTickets: 'Errore durante il caricamento dei ticket',
      loadingTicket: 'Errore durante il caricamento del ticket',
      createFailed: 'Impossibile creare il ticket',
      creatingTicket: 'Errore durante la creazione del ticket',
      updateFailed: 'Impossibile aggiornare il ticket',
      responseFailed: 'Impossibile inviare la risposta',
      sendingMessage: 'Errore durante l\'invio del messaggio',
      closingTicket: 'Errore durante la chiusura del ticket',
      ticketNotFound: 'Ticket non trovato',
      retry: 'Riprovare',
      fixFormErrors: 'Correggere gli errori nel modulo',
      subjectRequired: 'L\'oggetto è obbligatorio',
      subjectMinLength: 'L\'oggetto deve contenere almeno 5 caratteri',
      descriptionRequired: 'La descrizione è obbligatoria',
      descriptionMinLength: 'La descrizione deve contenere almeno 20 caratteri',
      categoryRequired: 'Seleziona una categoria'
    },
    success: {
      ticketCreated: 'Ticket {number} creato con successo',
      responseSent: 'Messaggio inviato',
      messageSent: 'Messaggio inviato',
      ticketClosed: 'Ticket chiuso con successo',
      ticketReopened: 'Ticket riaperto con successo'
    },
    // Additional FR-style keys
    manageRequests: 'Gestisci le tue richieste di assistenza',
    created: 'Creato',
    createdOn: 'Creato il',
    updated: 'Ultimo aggiornamento',
    resolved: 'Risolto',
    resolvedOn: 'Risolto il',
    noTicketsFound: 'Nessun ticket trovato',
    noTicketsYet: 'Non hai ancora creato un ticket di supporto',
    tryModifyingSearch: 'Prova a modificare i criteri di ricerca',
    createFirstTicket: 'Crea il mio primo ticket',
    sendMessage: 'Invia un messaggio',
    send: 'Invia',
    sending: 'Invio...',
    closing: 'Chiusura...',
    ticketClosed: 'Questo ticket è chiuso. Per una nuova richiesta, crea un nuovo ticket.',
    search: 'Cerca un ticket...',
    allStatuses: 'Tutti gli stati',
    refresh: 'Aggiorna',
    backToTickets: 'Torna ai ticket',
    ticketNumberLabel: 'Numero',
    you: 'Tu',
    supportTeam: 'Supporto SYLink',
    system: 'Sistema',
    writeReply: 'Scrivi la tua risposta...',
    detailedDescription: 'Descrizione dettagliata',
    informations: 'Informazioni',
    needHelp: 'Hai bisogno di aiuto?',
    responseTime: 'Tempo di risposta stimato',
    responseTimeDesc: 'Il nostro team risponde generalmente entro 24 ore lavorative. I ticket urgenti vengono gestiti con priorità. Riceverai una notifica via email non appena verrà fornita una risposta.',
    supportResponseDesc: 'Il nostro team di supporto risponde generalmente entro 24 ore lavorative. Per le urgenze, indica una priorità alta.',
    newTicketTitle: 'Nuovo Ticket',
    newTicketDesc: 'Descrivi il tuo problema e il nostro team ti risponderà rapidamente',
    describeIssue: 'Descrivi brevemente il tuo problema...',
    relatedWorkspace: 'Cliente / Workspace correlato (opzionale)',
    noSpecificWorkspace: 'Nessun workspace specifico',
    detailedDescPlaceholder: 'Descrivi il tuo problema in dettaglio. Più informazioni fornisci, più rapidamente potremo aiutarti...\n\n- Cosa stai cercando di fare?\n- Cosa sta succedendo?\n- Cosa ti aspettavi?\n- Hai un messaggio di errore?',
    charactersCount: '{count} caratteri',
    charactersMin: '{count} caratteri (minimo {min})',
    cancel: 'Annulla',
    creating: 'Creazione...',
    rateSupport: 'Come valuti la qualità del nostro supporto?',
    comment: 'Commento (opzionale)...',
    confirm: 'Conferma',
    messagesPlural: 'messaggi',
    resolutionNotes: 'Note di risoluzione',
    yourRating: 'La tua valutazione'
  },

  // Pricing
  pricing: {
    title: 'Scegli il tuo piano',
    subtitle: 'Soluzioni adatte a ogni esigenza di sicurezza',
    monthly: 'Mensile',
    annually: 'Annuale',
    save: 'Risparmia {percent}%',
    perMonth: '/mese',
    perYear: '/anno',
    currentPlan: 'Il tuo piano attuale',
    selectPlan: 'Seleziona',
    contactUs: 'Contattaci',
    popular: 'Popolare',
    enterprise: 'Enterprise',
    plans: {
      gratuit: {
        name: 'Gratuito',
        subtitle: 'Scoperta',
        description: 'Per scoprire la piattaforma',
        cta: 'Inizia gratuitamente',
        price: '0',
        features: [
          '1 scansione al mese',
          '1 workspace',
          'Report base',
          'Supporto community'
        ]
      },
      pro: {
        name: 'Pro',
        subtitle: 'Il più popolare',
        description: 'Per professionisti e PMI',
        cta: 'Scegli Pro',
        badge: 'Raccomandato',
        price: '99',
        features: [
          '50 scansioni al mese',
          '5 workspace',
          'Report avanzati PDF',
          'API access',
          'Supporto prioritario'
        ]
      },
      entreprise: {
        name: 'Enterprise',
        subtitle: 'Per i grandi team',
        description: 'Funzionalità avanzate e supporto dedicato',
        cta: 'Scegli Enterprise',
        price: '299',
        features: [
          'Scansioni illimitate',
          'Workspace illimitati',
          'Report white-label',
          'API completa',
          'SSO/SAML',
          'Account manager dedicato'
        ]
      },
      entreprise_plus: {
        name: 'Gruppo',
        subtitle: 'Per le grandi organizzazioni',
        description: 'Volume esteso e supporto premium',
        cta: 'Scegli Gruppo'
      },
      groupe: {
        name: 'Gruppo',
        subtitle: 'Per le grandi organizzazioni',
        description: 'Volume esteso e supporto premium',
        cta: 'Scegli Gruppo',
        price: 'Personalizzato',
        features: [
          'Tutte le funzionalità Enterprise',
          'Deployment on-premise',
          'Integrazioni personalizzate',
          'SLA garantito',
          'Formazione inclusa'
        ]
      },
      sur_mesure: {
        name: 'Su Misura',
        subtitle: 'Soluzione personalizzata',
        description: 'Adattata alle tue esigenze specifiche',
        cta: 'Contattaci'
      },
      dedicated: {
        name: 'Dedicato',
        description: 'Infrastruttura dedicata',
        price: 'Personalizzato',
        features: [
          'Server dedicati',
          'Personalizzazione completa',
          'Isolamento totale dei dati',
          'Audit di sicurezza',
          'Supporto 24/7'
        ]
      }
    },
    features: {
      scans: 'Scansioni',
      workspaces: 'Workspace',
      reports: 'Report',
      api: 'API Access',
      support: 'Supporto',
      sso: 'SSO/SAML',
      whitelabel: 'White-label',
      onpremise: 'On-premise',
      unlimited: 'Illimitato',
      simulationOnly: 'Solo modalità simulazione',
      oneUser: '1 utente',
      oneTarget: '1 obiettivo di test',
      basicDashboard: 'Dashboard base',
      realScans: 'Scansioni reali',
      pdfReports: 'Report PDF',
      technicalSupport: 'Supporto tecnico',
      apiAccess: 'Accesso API',
      unlimitedScans: 'Scansioni IA illimitate',
      fiveUsers: '5 utenti',
      tenTargets: '10 obiettivi',
      customPdfReports: 'Report PDF personalizzati',
      credentialSearch: 'Ricerca credenziali',
      autoScheduling: 'Pianificazione automatica',
      prioritySupport: 'Supporto prioritario',
      allProFeatures: 'Tutto il piano Pro +',
      fifteenUsers: '15 utenti',
      thirtyTargets: '30 obiettivi',
      ssoSaml: 'SSO / SAML',
      complianceAudit: 'Audit di conformità',
      slaGuarantee: 'SLA garantito 99,9%',
      dedicatedSupport: 'Supporto dedicato',
      teamTraining: 'Formazione team inclusa',
      allEnterpriseFeatures: 'Tutto il piano Enterprise +',
      unlimitedUsers: 'Utenti illimitati',
      fiftyTargets: '50 obiettivi',
      advancedWorkspaces: 'Multi-workspace avanzati',
      whiteLabelReports: 'Report personalizzabili',
      support24_7: 'Supporto dedicato 24/7',
      accountManager: 'Account manager dedicato',
      customOnboarding: 'Onboarding personalizzato',
      allGroupeFeatures: 'Tutto il piano Gruppo +',
      dedicatedInfra: 'Infrastruttura dedicata',
      customIntegrations: 'Integrazioni personalizzate',
      specificDevelopment: 'Sviluppi specifici',
      sourceCodeAudit: 'Audit del codice sorgente',
      manualPentest: 'Test di intrusione manuali',
      cissoSupport: 'Supporto CISO',
      customContract: 'Contratto su misura'
    },
    faq: {
      title: 'Domande frequenti',
      questions: {
        q1: {
          question: 'Posso cambiare piano in qualsiasi momento?',
          answer: 'Sì, puoi fare upgrade o downgrade del tuo piano in qualsiasi momento. La modifica sarà effettiva al prossimo ciclo di fatturazione.'
        },
        q2: {
          question: 'È disponibile un periodo di prova?',
          answer: 'Sì, offriamo 14 giorni di prova gratuita su tutti i piani a pagamento per testare la piattaforma.'
        },
        q3: {
          question: 'Quali metodi di pagamento accettate?',
          answer: 'Accettiamo carte di credito (Visa, Mastercard, Amex), bonifici bancari e PayPal.'
        },
        q4: {
          question: 'I prezzi includono l\'IVA?',
          answer: 'I prezzi visualizzati sono al netto dell\'IVA. L\'IVA verrà aggiunta in base al tuo paese.'
        }
      }
    },
    cta: {
      startTrial: 'Inizia la prova gratuita',
      getStarted: 'Inizia',
      talkToSales: 'Parla con le vendite',
      comparePlans: 'Confronta i piani'
    },
    // Additional FR-style pricing keys
    yearly: 'Annuale',
    yearlyDiscount: '-17%',
    perYear: '/anno',
    ht: 'IVA escl.',
    or: 'Ovvero',
    perMonthShort: '/mese',
    onQuote: 'Su preventivo',
    free: 'Gratuito',
    whyChoose: 'Perché scegliere SYLink Pentest?',
    aiTitle: 'Intelligenza Artificiale',
    aiDesc: 'La nostra IA analizza e sfrutta le vulnerabilità in modo autonomo, simulando il comportamento di un pentester esperto.',
    securityTitle: 'Sicurezza Massima',
    securityDesc: 'I tuoi dati sono cifrati e protetti. Nessuna informazione sensibile viene conservata dopo i test.',
    reportsTitle: 'Report Dettagliati',
    reportsDesc: 'Genera report PDF professionali con raccomandazioni di rimedio e scoring CVSS.',
    faqTitle: 'Domande frequenti',
    faqCanChangePlan: 'Posso cambiare piano?',
    faqCanChangePlanAnswer: 'Sì, puoi fare upgrade o downgrade del tuo piano in qualsiasi momento. Le modifiche sono effettive immediatamente e calcolate proporzionalmente.',
    faqFreePlan: 'Come funziona il piano gratuito?',
    faqFreePlanAnswer: 'Il piano gratuito ti permette di testare la piattaforma in modalità simulazione. Nessuna scansione reale viene effettuata ma scopri tutte le funzionalità.',
    faqCommitment: 'Esiste un impegno contrattuale?',
    faqCommitmentAnswer: 'No, nessun impegno. Puoi annullare in qualsiasi momento. La fatturazione annuale offre 2 mesi gratuiti.',
    faqSupport: 'Quale supporto è incluso?',
    faqSupportAnswer: 'Il piano Pro include un supporto prioritario via email. Il piano Enterprise beneficia di un supporto dedicato 24/7.',
    needHelpChoosing: 'Hai bisogno di aiuto per scegliere?',
    needHelpDesc: 'Il nostro team è disponibile per consigliarti e rispondere a tutte le tue domande. Ottieni una demo personalizzata della piattaforma.',
    needHelpDescShort: 'Il nostro team è disponibile per accompagnarti e rispondere a tutte le tue domande.',
    requestCall: 'Richiedi una chiamata',
    welcomeTitle: 'Benvenuto su SYLink Pentest!',
    welcomeDesc: 'Il tuo account è attivato. Scegli il piano più adatto alle tue esigenze.',
    welcomeDescShort: 'Scegli il piano più adatto alle tue esigenze',
    paymentError: 'Errore di pagamento',
    close: 'Chiudi',
    redirecting: 'Reindirizzamento...',
    securedByStripe: 'Pagamento protetto da Stripe',
    detailedComparison: 'Confronto dettagliato',
    infrastructureOptions: 'Opzioni di infrastruttura',
    infrastructureDesc: 'Scegli la modalità di deployment adatta alle tue esigenze e vincoli',
    choosePlan: 'Scegli il tuo',
    choosePlanHighlight: 'piano',
    pageSubtitle: 'Automatizza i test di intrusione con l\'IA. Dal freelance all\'azienda, abbiamo il piano che fa per te.',
    contactBanner: 'Tutti i nostri piani sono personalizzati alle tue esigenze',
    foreverFree: 'Per sempre',
    customPricing: 'Su preventivo',
    customPricingLabel: 'Tariffazione personalizzata',
    perMonthHT: '/mese IVA escl.',
    billedPerYear: 'Fatturato',
    billedPerYearSuffix: '/anno',
    requestQuote: 'Richiedi un preventivo',
    startFree: 'Inizia gratuitamente',
    learnMoreDedicated: 'Scopri i server dedicati',
    readOnlyApi: 'Sola lettura',
    featureRow: 'Funzionalità',
    priceRow: 'Prezzo',
    planFeatures: {
      simulationOnly: 'Solo modalità simulazione',
      oneUser: '1 utente',
      oneTarget: '1 obiettivo di test',
      basicDashboard: 'Dashboard base',
      realScans: 'Scansioni reali',
      pdfReports: 'Report PDF',
      technicalSupport: 'Supporto tecnico',
      apiAccess: 'Accesso API',
      unlimitedScans: 'Scansioni IA illimitate',
      fiveUsers: '5 utenti',
      tenTargets: '10 obiettivi',
      customPdfReports: 'Report PDF personalizzati',
      credentialSearch: 'Ricerca credenziali',
      autoScheduling: 'Pianificazione automatica',
      prioritySupport: 'Supporto prioritario',
      allProFeatures: 'Tutto il piano Pro +',
      fifteenUsers: '15 utenti',
      thirtyTargets: '30 obiettivi',
      ssoSaml: 'SSO / SAML',
      complianceAudit: 'Audit di conformità',
      slaGuarantee: 'SLA garantito 99,9%',
      dedicatedSupport: 'Supporto dedicato',
      teamTraining: 'Formazione team inclusa',
      allEnterpriseFeatures: 'Tutto il piano Enterprise +',
      unlimitedUsers: 'Utenti illimitati',
      fiftyTargets: '50 obiettivi',
      advancedWorkspaces: 'Multi-workspace avanzati',
      whiteLabelReports: 'Report personalizzabili',
      support24_7: 'Supporto dedicato 24/7',
      accountManager: 'Account manager dedicato',
      customOnboarding: 'Onboarding personalizzato',
      allGroupeFeatures: 'Tutto il piano Gruppo +',
      dedicatedInfra: 'Infrastruttura dedicata',
      customIntegrations: 'Integrazioni personalizzate',
      specificDevelopment: 'Sviluppi specifici',
      sourceCodeAudit: 'Audit del codice sorgente',
      manualPentest: 'Test di intrusione manuali',
      cissoSupport: 'Supporto CISO',
      customContract: 'Contratto su misura'
    },
    planDetails: {
      gratuit: {
        subtitle: 'Scoperta',
        cta: 'Inizia gratuitamente'
      },
      pro: {
        subtitle: 'Il più popolare',
        badge: 'Raccomandato',
        cta: 'Scegli Pro'
      },
      entreprise: {
        subtitle: 'Per i grandi team',
        cta: 'Scegli Enterprise'
      },
      entreprise_plus: {
        name: 'Gruppo',
        subtitle: 'Per le grandi organizzazioni',
        cta: 'Scegli Gruppo'
      },
      sur_mesure: {
        name: 'Su Misura',
        subtitle: 'Soluzione personalizzata',
        cta: 'Contattaci'
      }
    }
  },

  // Notifications
  notifications: {
    title: 'Notifiche',
    managementCenter: 'Centro di gestione degli avvisi e degli eventi',
    markAllRead: 'Segna tutto come letto',
    clearAll: 'Cancella tutto',
    noNotifications: 'Nessuna notifica',
    noNotificationsDescription: 'Non hai alcuna notifica al momento',
    viewAll: 'Visualizza tutte le notifiche',
    settings: 'Impostazioni notifiche',
    loadMore: 'Carica altre',
    justNow: 'Proprio ora',
    minutesAgo: '{count} minuti fa',
    hoursAgo: '{count} ore fa',
    daysAgo: '{count} giorni fa',
    scanRunning: 'Scansione in corso',
    scanCompleted: 'Scansione completata',
    criticalVulnsFound: '{count} vulnerabilità critica{count, plural, =1 {} other {}}',
    types: {
      scan_completed: 'Scansione completata',
      scan_failed: 'Scansione fallita',
      vulnerability_found: 'Vulnerabilità rilevata',
      report_ready: 'Report pronto',
      subscription_expiring: 'Abbonamento in scadenza',
      credits_low: 'Crediti bassi',
      new_feature: 'Nuova funzionalità',
      system: 'Sistema'
    },
    filters: {
      all: 'Tutte',
      unread: 'Non lette',
      read: 'Lette',
      important: 'Importanti'
    },
    preferences: {
      title: 'Preferenze di notifica',
      email: 'Notifiche email',
      push: 'Notifiche push',
      inApp: 'Notifiche in-app',
      scanUpdates: 'Aggiornamenti scansioni',
      securityAlerts: 'Avvisi di sicurezza',
      productNews: 'Novità prodotto',
      weeklyReport: 'Report settimanale'
    },
    status: {
      read: 'Letto',
      unread: 'Non letto'
    },
    // Additional FR-style notification keys
    aiAssistant: 'Assistente IA',
    aiAssistantTitle: 'Assistente IA - Notifiche',
    aiPlaceholder: 'Fai una domanda sulle tue notifiche...',
    soundEnabled: 'Suoni attivati',
    criticalOnly: 'Solo critiche',
    autoMarkRead: 'Segna letto automaticamente',
    filtersLabel: 'Filtri',
    total: 'Totale',
    unreadCount: 'Non lette',
    critical: 'Critiche',
    warning: 'Attenzione',
    info: 'Informazioni',
    allRead: 'Tutte le notifiche sono state lette',
    noNotificationsType: 'Nessuna notifica di tipo "{type}"',
    typeCritical: 'Critica',
    typeWarning: 'Attenzione',
    typeSuccess: 'Successo',
    typeInfo: 'Info',
    vulnsDetected: '{count} vulnerabilità rilevata{count, plural, =1 {} other {}}',
    hostsScanned: '{count} host scansionati su {target}',
    scanCompletedNoVulns: 'Scansione completata - Nessuna vulnerabilità',
    noVulnsDetected: 'Nessuna vulnerabilità rilevata su {target}',
    scanInProgress: 'Scansione in corso',
    analyzing: 'Analisi di {target}...',
    scanFailed: 'Scansione fallita',
    errorOn: 'Errore su {target}',
    // FR-style flat keys missing
    filters: 'Filtri',
    unread: 'Non lette',
    success: 'Successo',
    noNotificationsDesc: 'Non hai alcuna notifica al momento'
  },

  // Antivirus (ClamAV)
  antivirus: {
    title: 'Scanner Antivirus',
    subtitle: 'Scansiona i file alla ricerca di malware con ClamAV',
    adminTitle: 'Gestione Antivirus',
    adminSubtitle: 'Monitora ClamAV e gestisci la quarantena',
    scannerTab: 'Scanner File',
    adminTab: 'Amministrazione',

    // File Upload
    dropzone: 'Trascina un file qui o clicca per caricare',
    dropzoneActive: 'Rilascia il file qui...',
    scanning: 'Scansione in corso...',
    uploadAndScan: 'Carica e Scansiona',
    maxFileSize: 'Dimensione massima file: {size}',

    // Scan Results
    scanResult: 'Risultato scansione',
    clean: 'Pulito',
    infected: 'Infetto',
    error: 'Errore',
    pending: 'In attesa',
    threatDetected: 'Minaccia rilevata',
    noThreatsFound: 'Nessuna minaccia trovata',
    threatName: 'Nome minaccia',
    scanTime: 'Tempo di scansione',
    fileHash: 'Hash file',

    // History
    scanHistory: 'Cronologia scansioni',
    noScansYet: 'Nessuna scansione ancora',
    noScansYetDesc: 'Carica un file per iniziare la scansione',

    // Admin Dashboard
    clamavStatus: 'Stato ClamAV',
    version: 'Versione',
    signatureCount: 'Numero firme',
    lastUpdate: 'Ultimo aggiornamento',
    databaseStatus: 'Stato database',
    upToDate: 'Aggiornato',
    outdated: 'Obsoleto',

    // Statistics
    statistics: 'Statistiche',
    totalScans: 'Scansioni totali',
    cleanFiles: 'File puliti',
    infectedFiles: 'File infetti',
    errorScans: 'Scansioni con errore',

    // Quarantine
    quarantine: 'Quarantena',
    quarantineEmpty: 'Quarantena vuota',
    quarantineEmptyDesc: 'Nessun file in quarantena',
    deleteFromQuarantine: 'Elimina dalla quarantena',
    cleanupQuarantine: 'Pulisci quarantena',

    // Errors
    uploadError: 'Errore durante il caricamento del file',
    scanError: 'Errore durante la scansione del file',
    fileTooLarge: 'Il file è troppo grande',
    invalidFileType: 'Tipo di file non valido',
    serviceUnavailable: 'Servizio antivirus non disponibile',
    // FR-style flat keys
    scanFile: 'Scansiona un file',
    scanNow: 'Scansiona ora',
    scanAll: 'Scansiona tutti i file',
    dropOrClick: 'Trascina un file o clicca per selezionare',
    dropFiles: 'Trascina i file qui o clicca per selezionare',
    maxSize: 'Dimensione massima per file',
    selectedFiles: 'File selezionati',
    recentScans: 'Scansioni recenti',
    summary: 'Riepilogo dell\'analisi',
    unavailable: 'ClamAV non disponibile',
    dataScanned: 'Dati analizzati',
    threatsBySeverity: 'Minacce per severità',
    performance: 'Prestazioni',
    avgScanTime: 'Tempo medio di scansione',
    cacheEntries: 'Voci in cache',
    filename: 'Nome file',
    size: 'Dimensione',
    status: 'Stato',
    threat: 'Minaccia',
    severity: 'Severità',
    scannedAt: 'Analizzato',
    daemonStatus: 'Stato del demone',
    signatureVersion: 'Versione delle firme',
    reloadSignatures: 'Ricarica le firme',
    noQuarantine: 'Nessun file in quarantena',
    quarantinedAt: 'Messo in quarantena',
    expiresAt: 'Scade',
    cleanupExpired: 'Pulisci i file scaduti',
    confirmDelete: 'Sei sicuro di voler eliminare definitivamente questo file?',
    typeNotAllowed: 'Tipo di file non consentito',
    total: 'Totale'
  },

  // Contracts
  contracts: {
    title: 'Contratti',
    contract: 'Contratto',
    newContract: 'Nuovo contratto',
    createContract: 'Crea contratto',
    editContract: 'Modifica contratto',
    contractNumber: 'Numero contratto',
    contractTitle: 'Titolo',

    // Status
    status: {
      draft: 'Bozza',
      pending_signature: 'In attesa di firma',
      signed: 'Firmato',
      active: 'Attivo',
      completed: 'Completato',
      expired: 'Scaduto',
      cancelled: 'Annullato'
    },

    // Provider
    provider: 'Fornitore',
    providerInfo: 'Informazioni fornitore',
    providerName: 'Nome azienda',
    providerSiret: 'SIRET',
    providerAddress: 'Indirizzo',

    // Client
    client: 'Cliente',
    clientInfo: 'Informazioni cliente',
    clientName: 'Nome azienda',
    clientRepresentative: 'Rappresentante del cliente',
    clientContact: 'Contatto',

    // Perimeter
    perimeter: 'Perimetro',
    perimeterDescription: 'Intervalli IP e obiettivi da testare',
    addPerimeterItem: 'Aggiungi elemento al perimetro',

    // Period
    interventionPeriod: 'Periodo di intervento',
    startDate: 'Data inizio',
    endDate: 'Data fine',
    riskPeriod: 'Periodo di rischio (giorni)',

    // Signature
    signature: {
      title: 'Firma elettronica',
      sign: 'Firma',
      signed: 'Firmato',
      pendingSignature: 'In attesa di firma',
      signContract: 'Firma contratto',
      signatureType: 'Tipo di firma',
      typed: 'Digitata',
      drawn: 'Disegnata',
      uploaded: 'Caricata',

      // Signatory
      signatory: 'Firmatario',
      signatoryInfo: 'Identità del firmatario',
      signatoryFirstName: 'Nome',
      signatoryLastName: 'Cognome',
      signatoryEmail: 'Email',
      signatoryFullName: 'Nome completo',

      // Legal
      legalMention: 'Menzione legale',
      legalAcceptance: 'Accetto i termini del contratto',
      acceptTerms: 'Confermo di aver letto e accettato questo contratto di pentest',

      // Verification
      verification: 'Verifica',
      verificationMethod: 'Metodo di verifica',
      smsVerification: 'Verifica SMS',
      smsCode: 'Codice SMS',
      sendCode: 'Invia codice',
      verifyCode: 'Verifica codice',
      codeExpired: 'Codice scaduto',
      invalidCode: 'Codice non valido',
      codeSent: 'Codice inviato al tuo telefono',

      // Metadata (DocuSign-style)
      metadata: 'Metadati della firma',
      signedBy: 'Firmato da',
      signedAt: 'Firmato il',
      signedAtTime: 'Ora della firma',
      ipAddress: 'Indirizzo IP',
      userAgent: 'Browser / Dispositivo',
      geolocation: 'Posizione',

      // Certificate
      certificate: 'Certificato di firma',
      certificateOfCompletion: 'Certificato di completamento',
      signatureCertificate: 'Certificato di firma',
      downloadCertificate: 'Scarica certificato',
      viewCertificate: 'Visualizza certificato',

      // Integrity
      integrity: 'Integrità del documento',
      documentHash: 'Hash del documento (SHA-512)',
      signatureHash: 'Hash della firma (SHA-512)',
      hashVerified: 'Hash verificato',
      hashMismatch: 'Errore hash',

      // Timeline / Audit
      timeline: 'Cronologia',
      auditTrail: 'Registro di audit',
      eventLog: 'Registro eventi',
      created: 'Creato',
      sent: 'Inviato',
      viewed: 'Visualizzato',
      signatureStarted: 'Firma avviata',
      signatureCompleted: 'Firma completata',

      // Success
      success: 'Contratto firmato con successo!',
      successMessage: 'Il contratto è stato firmato ed è ora attivo.',
      thankYou: 'Grazie per la tua firma',

      // Errors
      error: 'Errore di firma',
      errorMessage: 'Impossibile firmare il contratto',
      expired: 'Link di firma scaduto',
      alreadySigned: 'Contratto già firmato',
      invalidToken: 'Link di firma non valido'
    },

    // Actions
    send: 'Invia per la firma',
    resend: 'Invia di nuovo',
    cancel: 'Annulla contratto',
    download: 'Scarica PDF',
    downloadSigned: 'Scarica PDF firmato',
    preview: 'Anteprima',

    // Notifications
    sentSuccess: 'Contratto inviato per la firma',
    signedSuccess: 'Contratto firmato con successo',
    cancelledSuccess: 'Contratto annullato',
    // FR-style flat status keys
    contractNumber: 'Riferimento contratto',
    statusLabel: 'Stato',
    draft: 'Bozza',
    pendingSignature: 'In attesa di firma',
    signed: 'Firmato',
    active: 'Attivo',
    expired: 'Scaduto',
    cancelled: 'Annullato',
    archived: 'Archiviato'
  },

  // VPN Configuration
  vpn: {
    title: 'Configurazione VPN',
    configurations: 'Configurazioni VPN',
    noConfigurations: 'Nessuna configurazione VPN',
    uploadConfig: 'Carica configurazione',
    connected: 'Connesso',
    disconnected: 'Disconnesso',
    connecting: 'Connessione...',
    disconnecting: 'Disconnessione...',
    connect: 'Connetti',
    disconnect: 'Disconnetti',
    status: 'Stato VPN',
    protocol: 'Protocollo',
    interface: 'Interfaccia',
    publicIp: 'IP Pubblico',
    vpnIp: 'IP VPN',
    country: 'Paese',
    city: 'Città',
    connectedSince: 'Connesso da',
    routes: {
      title: 'Route di Rete',
      description: 'Gestisci route di rete personalizzate per VPN',
      addRoute: 'Aggiungi route',
      destination: 'Destinazione CIDR',
      destinationPlaceholder: '192.168.56.0/24',
      gateway: 'Gateway',
      gatewayPlaceholder: '192.168.10.1',
      routeDescription: 'Descrizione',
      routeDescriptionPlaceholder: 'Rete interna cliente',
      noRoutes: 'Nessuna route configurata',
      deleteRoute: 'Elimina route',
      applyRoutes: 'Applica route',
      routeAdded: 'Route aggiunta con successo',
      routeDeleted: 'Route eliminata',
      routesApplied: 'Route applicate',
      invalidCidr: 'Formato CIDR non valido',
      invalidGateway: 'Indirizzo IP non valido',
      active: 'Attiva',
      inactive: 'Inattiva'
    },
    topology: {
      title: 'Topologia di Rete',
      server: 'Server Sylink',
      internet: 'Internet',
      vpnGateway: 'Gateway VPN',
      clientNetwork: 'Rete Cliente',
      online: 'Online',
      offline: 'Offline',
      activeRoutes: 'Route attive',
      totalRoutes: 'Route totali',
      networkGateway: 'Gateway di Rete',
      subnetsCount: '{{count}} sottoreti'
    },
    messages: {
      configUploaded: 'Configurazione VPN caricata',
      configDeleted: 'Configurazione VPN eliminata',
      connectionSuccess: 'VPN connesso con successo',
      connectionFailed: 'Errore connessione VPN',
      disconnectionSuccess: 'VPN disconnesso',
      disconnectionFailed: 'Errore disconnessione VPN',
      saveError: 'Errore durante il salvataggio',
      deleteError: 'Errore durante l\'eliminazione',
      connectError: 'Errore di connessione VPN',
      disconnectError: 'Errore di disconnessione VPN'
    },
    server: 'Server',
    saveCredentials: 'Salva le credenziali per questa VPN',
    loadingWorkspaces: 'Caricamento workspace...',
    noWorkspace: 'Nessun workspace',
    noWorkspaceAvailable: 'Nessun workspace disponibile',
    noVpnFoundFor: 'Nessuna VPN trovata per "{query}"',
    deleteStoredCredentialsTitle: 'Elimina le credenziali salvate',
    saveCredentialsSecurely: 'Salva le credenziali in modo sicuro',
    saveCredentialsNow: 'Salva ora',
    noVpnAvailable: 'Nessuna configurazione VPN disponibile',
    loadingConfigs: 'Caricamento configurazioni VPN...'
  },

  // Severity levels
  severity: {
    critical: 'Critico',
    high: 'Alto',
    medium: 'Medio',
    low: 'Basso',
    info: 'Info'
  },

  // APT Modules
  apt: {
    dangerousModule: 'Modulo pericoloso - Usare con cautela',
    addToChain: 'Aggiungi a una catena',
    createChain: 'Crea una catena di attacco',
    createChainButton: 'Crea catena',
    chainName: 'Nome della catena',
    selectedModules: 'Moduli selezionati',
    addModulesFromList: 'Aggiungi moduli dall\'elenco a destra',
    availableModules: 'Moduli disponibili',
    newChain: 'Nuova catena',
    executeModule: 'Esegui {name}',
    loadError: 'Errore nel caricamento dei dati APT',
    requiredParams: 'Parametri richiesti',
    executions: 'Esecuzioni',
    successful: 'riuscite',
    avgTime: 'Tempo medio',
    modulesApt: 'Moduli APT',
    chains: 'Catene',
    evidence: 'Prove',
    mitreMatrix: 'Matrice MITRE ATT&CK',
    category: 'Categoria',
    criticality: 'Criticità',
    mitreTactic: 'Tattica MITRE',
    allCategories: 'Tutte',
    allCriticalities: 'Tutte',
    allTactics: 'Tutte',
    low: 'Basso',
    medium: 'Medio',
    high: 'Alto',
    critical: 'Critico',
    noModulesAvailable: 'Nessuna campagna APT disponibile al momento',
    noModulesFiltered: 'Nessun modulo corrisponde ai filtri selezionati',
    noChains: 'Nessuna catena di attacco creata. Creane una per iniziare.',
    noEvidence: 'Nessuna prova raccolta. Esegui moduli per raccogliere prove.',
    chainStatus: 'Stato',
    chainProgress: 'Avanzamento',
    chainModules: 'Moduli',
    chainCreatedAt: 'Creato il',
    executeChain: 'Esegui {name}',
    moduleLaunched: 'Modulo {name} avviato',
    moduleLaunchError: 'Errore nell\'avvio del modulo',
    chainCreated: 'Catena creata con successo',
    chainCreateError: 'Errore nella creazione della catena',
    chainLaunched: 'Catena avviata',
    chainLaunchError: 'Errore nell\'avvio della catena',
    chainPaused: 'Catena in pausa',
    chainCancelled: 'Catena annullata',
    dangerWarning: 'Questo modulo è contrassegnato come pericoloso. Usarlo con cautela.',
    modulesAvailable: 'moduli disponibili',
    target: 'Obiettivo',
    duration: 'Durata',
    result: 'Risultato',
    title: 'Titolo',
    classification: 'Classificazione',
    size: 'Dimensione',
    validated: 'Validato',
    searchPlaceholder: 'Cerca...',
    tool: 'Strumento',
    module: 'Modulo',
    exitCode: 'Codice di uscita',
    status: {
      pending: 'In attesa',
      queued: 'In coda',
      running: 'In corso',
      paused: 'In pausa',
      completed: 'Completato',
      failed: 'Fallito',
      cancelled: 'Annullato',
      draft: 'Bozza',
      ready: 'Pronto'
    },
    categories: {
      reconnaissance: 'Ricognizione',
      resource_development: 'Sviluppo risorse',
      initial_access: 'Accesso iniziale',
      execution: 'Esecuzione',
      persistence: 'Persistenza',
      privilege_escalation: 'Escalation privilegi',
      defense_evasion: 'Evasione difese',
      credential_access: 'Accesso credenziali',
      discovery: 'Scoperta',
      lateral_movement: 'Movimento laterale',
      collection: 'Raccolta',
      command_and_control: 'Comando e controllo',
      exfiltration: 'Esfiltrazione',
      impact: 'Impatto'
    },
    criticalities: {
      low: 'Basso',
      medium: 'Medio',
      high: 'Alto',
      critical: 'Critico'
    }
  },

  // Equipment
  equipment: {
    title: 'Gestione apparecchiature',
    subtitle: 'Rileva, categorizza e attacca le apparecchiature di rete',
    totalEquipment: 'Totale apparecchiature',
    totalEquipmentDesc: 'Numero totale di apparecchiature registrate nel database.',
    equipmentLabel: 'apparecchiature',
    totalAttacks: 'Totale attacchi',
    attacksLabel: 'attacchi',
    successfulAttacks: 'Attacchi riusciti',
    successfulAttacksLabel: 'riusciti',
    ongoingAttacks: 'Attacchi in corso',
    ongoingAttacksLabel: 'in corso',
    typesTab: 'Tipi di apparecchiature',
    detectedTab: 'Apparecchiature rilevate',
    attacksTab: 'Attacchi',
    autoDetect: 'Auto-Rilevamento',
    refresh: 'Aggiorna',
    searchPlaceholder: 'Cerca…',
    category: 'Categoria',
    allCategories: 'Tutte'
  },

  // Workspace selector
  workspace: {
    select: 'Seleziona uno spazio di lavoro',
    selectTitle: 'Selezione spazio di lavoro',
    selectDescription: 'Scegli uno spazio di lavoro per continuare',
    searchPlaceholder: 'Cerca uno spazio di lavoro...',
    noWorkspaces: 'Nessuno spazio di lavoro disponibile',
    noWorkspacesYet: 'Nessuno spazio di lavoro creato',
    noResults: 'Nessuno spazio di lavoro trovato',
    createFirst: 'Crea il tuo primo spazio di lavoro',
    createNew: 'Crea uno spazio di lavoro',
    manageAll: 'Gestisci gli spazi di lavoro',
    continue: 'Continua',
    switchError: 'Errore nel cambio di spazio di lavoro',
    switchSuccess: 'Spazio di lavoro cambiato con successo',
    scan: 'scansione',
    scans: 'scansioni',
    createRequired: 'Spazio di lavoro richiesto',
    createRequiredDescription: 'È necessario creare uno spazio di lavoro per accedere a questa sezione.',
    selectRequired: 'Selezione richiesta',
    selectRequiredDescription: 'Seleziona uno spazio di lavoro per accedere a questa sezione. Hai',
    workspaceAvailable: 'spazio di lavoro disponibile.',
    workspacesAvailable: 'spazi di lavoro disponibili.',
    selectWorkspace: 'Seleziona uno spazio di lavoro'
  },

  // Phishing Simulation
  phishing: {
    title: 'Simulazione di Phishing',
    subtitle: 'Testa la consapevolezza sulla sicurezza dei dipendenti con campagne di phishing simulate',
    campaignsTab: 'Campagne',
    templatesTab: 'Modelli',
    targetsTab: 'Gruppi target',
    analyticsTab: 'Statistiche',
    settingsTab: 'Impostazioni',
    totalCampaigns: 'Totale campagne',
    emailsSent: 'Email inviate',
    clickRate: 'Tasso di clic',
    reportRate: 'Tasso di segnalazione',
    recentCampaigns: 'Campagne recenti',
    newCampaign: 'Nuova campagna',
    campaignName: 'Nome della campagna',
    status: 'Stato',
    sent: 'Inviati',
    opened: 'Aperti',
    clicked: 'Cliccati',
    reported: 'Segnalati',
    actions: 'Azioni',
    viewDetails: 'Visualizza dettagli',
    emailTemplates: 'Modelli email',
    createTemplate: 'Crea modello',
    targetGroups: 'Gruppi target',
    createGroup: 'Crea gruppo',
    groupName: 'Nome del gruppo',
    members: 'Membri',
    lastUsed: 'Ultimo utilizzo',
    edit: 'Modifica',
    delete: 'Elimina',
    analyticsOverview: 'Panoramica delle analisi',
    clickRateTrend: 'Tendenza del tasso di clic',
    reportRateTrend: 'Tendenza del tasso di segnalazione',
    chartPlaceholder: 'Il grafico verrà visualizzato qui',
    departmentComparison: 'Confronto per reparto',
    settings: 'Impostazioni Phishing',
    smtpConfig: 'Configurazione SMTP',
    smtpServer: 'Server SMTP',
    smtpPort: 'Porta SMTP',
    trackingSettings: 'Impostazioni di tracciamento',
    trackOpens: 'Traccia aperture email',
    trackClicks: 'Traccia clic sui link',
    trackSubmissions: 'Traccia invii di credenziali',
    saveSettings: 'Salva impostazioni',
    reference: 'Riferimento',
    statusCompleted: 'Completato',
    statusActive: 'Attiva',
    statusScheduled: 'Pianificata',
    statusCancelled: 'Annullata',
    statusDraft: 'Bozza',
    categoryCredentialHarvest: 'Raccolta credenziali',
    categoryLinkClick: 'Clic su link',
    categoryAttachment: 'Allegato'
  },

  // Sankey Analysis
  sankey: {
    title: 'Diagramma di Flusso della Sicurezza',
    clickForAiAnalysis: 'Clicca su un elemento per l\'analisi IA',
    exploitable: 'Sfruttabile',
    nonExploitable: 'Non sfruttabile',
    columns: {
      workspaces: 'Spazi di lavoro',
      targets: 'Obiettivi',
      assets: 'Asset',
      vulnerabilities: 'Vulnerabilità',
      exploitability: 'Sfruttabilità',
      cve: 'CVE'
    },
    legend: {
      workspaces: 'Spazi di lavoro',
      targets: 'Obiettivi',
      critical: 'Critico',
      nonExploitable: 'Non exploit.'
    },
    severity: {
      critical: 'Critici',
      high: 'Alti',
      medium: 'Medi',
      low: 'Bassi'
    },
    analysis: {
      model: 'Modello',
      changeModel: 'Analizza con un altro LLM',
      selectModel: 'Seleziona modello LLM',
      regenerateWith: 'Rigenera analisi con un altro modello',
      recommended: 'Raccomandato',
      regenerate: 'Rigenera analisi'
    },
    noScansAvailable: 'Nessuna scansione disponibile per la visualizzazione',
    scansLabel: 'scansioni',
    hostsLabel: 'host',
    portsLabel: 'porte',
    occurrences: 'occorrenza/e',
    tooltip: {
      element: 'Elemento',
      scansHostsVulns: '{scans} scansioni • {hosts} host • {vulns} vulnerabilità',
      ipHostsVulns: '{ip} • {hosts} host • {vulns} vulnerabilità',
      vulnsCount: '{count} vulnerabilità',
      clickForAi: 'Clicca per analisi IA'
    },
    stats: {
      workspaces: 'Spazi di lavoro',
      targets: 'Obiettivi',
      assets: 'Asset',
      vulnerabilities: 'Vulnerabilità',
      exploitable: 'Sfruttabile'
    }
  },

  // LLM Monitor
  llmMonitor: {
    title: 'Orchestratore LLM',
    subtitle: 'Gestione e supervisione dei modelli con accelerazione GPU',
    gpuStatus: 'Stato GPU',
    vram: 'VRAM',
    utilization: 'Utilizzo',
    load: 'Carica',
    loaded: 'Caricato',
    noTarget: 'Nessun obiettivo',
    entries: 'voci',
    vulnerabilities: 'vulnerabilità',
    credentials: 'credenziali',
    poolStatus: 'Stato Pool GPU',
    servers: 'server',
    moreModels: 'in più',
    orchestratorMetrics: 'Metriche dell\'Orchestratore',
    totalRequests: 'Richieste totali',
    modelSwaps: 'Scambi modello',
    avgSwapTime: 'Tempo medio scambio',
    inferences: 'Inferenze',
    connected: 'Connesso',
    disconnected: 'Disconnesso',
    refresh: 'Aggiorna',
    availableModels: 'Modelli disponibili',
    activeSessions: 'Sessioni attive',
    noActiveSessions: 'Nessuna sessione attiva',
    noSessionsHint: 'Le sessioni LLM usano l\'intelligenza artificiale per analizzare automaticamente le vulnerabilità.',
    noSessionsAction: 'Avvia una sessione',
    readyStatus: 'Pronto per iniziare',
    howToStart: 'Avvia una scansione per iniziare una sessione LLM',
    waitingForScan: 'In attesa di una scansione',
    quickActions: 'Azioni rapide',
    newSession: 'Nuova sessione',
    requestCheckpoint: 'Richiedi un checkpoint',
    hashcatTasks: 'Attività Hashcat',
    loadStatusFailed: 'Errore nel caricamento dello stato LLM',
    loadingModel: 'Caricamento di {{model}}...',
    swapFailed: 'Errore nel cambio di modello',
    noModel: 'Nessuno',
    online: 'Online',
    offline: 'Offline',
    serviceUnavailable: 'Servizio LLM non disponibile'
  },

  // Tool Categories
  toolCategories: {
    reconnaissance: 'Ricognizione',
    web: 'Scanner Web',
    cms: 'Scanner CMS',
    vulnerabilities: 'Scanner di Vulnerabilità',
    bruteforce: 'Forza Bruta',
    ad: 'Active Directory',
    ldap: 'LDAP / LDAPS',
    services: 'Enumerazione Servizi',
    osint: 'Intelligence open source (OSINT)',
    suites: 'Suite di Sicurezza',
    ssl: 'SSL/TLS',
    ot: 'OT/ICS/SCADA',
    iot: 'Dispositivi IoT',
    pivoting: 'Pivoting e Tunneling',
    privesc: 'Escalation Privilegi',
    evasion: 'Evasione e Bypass',
    supply_chain: 'Sicurezza della Supply Chain',
    network_attack: 'Attacchi di Rete',
    firewall: 'Box / Firewall / Router',
    vpn: 'Sicurezza VPN',
    cloud: 'Sicurezza Cloud',
    other: 'Altro'
  },

  // OSINT
  osint: {
    scanTypes: {
      virustotal: 'VirusTotal',
      headers: 'Intestazioni di sicurezza',
      security_headers: 'Intestazioni di sicurezza',
      email_security: 'Sicurezza email',
      geoip: 'Geolocalizzazione IP',
      reverse_ip: 'IP inverso',
      full: 'Scansione completa',
      domain: 'Dominio',
      ip: 'Indirizzo IP',
      url: 'URL',
      network_discovery: 'Scoperta rete',
      vulnerability_scan: 'Scansione vulnerabilità',
      full_autonomous: 'Autonomo completo',
      full_auto: 'Autonomo completo',
      full_automation: 'Autonomo completo',
      expert: 'Scansione esperta',
      api_pentest: 'Pentest API',
      iot_scan: 'Scansione IoT',
      ot_scan: 'Scansione OT/SCADA',
      ad_pentest: 'Pentest AD',
      ad_scan: 'Scansione Active Directory',
      ad_recon: 'Ricognizione AD',
      ad_full: 'Scansione AD completa',
      ldap_scan: 'Scansione LDAP',
      kerberos_scan: 'Scansione Kerberos',
      web_scan: 'Scansione Web',
      web: 'Scansione Web',
      quick: 'Rapida',
      quick_scan: 'Scansione rapida',
      discovery: 'Scoperta',
      enumeration: 'Enumerazione',
      vulnerability: 'Vulnerabilità',
      exploitation: 'Sfruttamento',
      passive: 'Passivo',
      aggressive: 'Aggressivo',
      credentials: 'Credenziali',
      recon: 'Ricognizione',
      exploit: 'Exploit',
      bypass: 'Bypass',
      nmap: 'Scansione Nmap',
      nikto: 'Scansione Nikto',
      internal: 'Scansione interna',
      external: 'Scansione esterna',
      network: 'Scansione rete',
      owasp: 'Scansione OWASP',
      owasp_scan: 'Scansione OWASP',
      owasp_top10: 'OWASP Top 10',
      owasp_top_10: 'OWASP Top 10',
      zap: 'Scansione ZAP',
      zap_scan: 'Scansione ZAP',
      owasp_zap: 'Scansione OWASP ZAP',
      sqlmap: 'Scansione SQLMap',
      openvas: 'Scansione OpenVAS',
      nuclei: 'Scansione Nuclei',
      metasploit: 'Scansione Metasploit',
      hydra: 'Test Hydra',
      wpscan: 'Scansione WordPress',
      gobuster: 'Scansione Gobuster',
      pentest: 'Pentest',
      stealth: 'Scansione furtiva',
      full_scan: 'Scansione completa',
      standard: 'Standard'
    }
  },

  // Agents
  agents: {
    title: 'Agenti',
    subtitle: 'Agenti di scansione distribuiti nelle reti interne',
    loading: 'Caricamento agenti...',
    register: 'Registra',
    registerAgent: 'Registra un agente',
    downloadInstaller: 'Scarica il programma di installazione',
    searchPlaceholder: 'Cerca un agente...',
    noAgentsFound: 'Nessun agente trovato',
    noAgentsRegistered: 'Nessun agente registrato',
    noAgentsFoundHint: 'Modifica la ricerca o registra un nuovo agente',
    noAgentsRegisteredHint: 'Distribuisci un agente su una rete client per scansionare obiettivi interni senza VPN',
    loadError: 'Errore nel caricamento degli agenti',
    deleteConfirm: 'Eliminare l\'agente "{name}"?',
    colAgent: 'Agente',
    colStatus: 'Stato',
    colHostname: 'Hostname',
    colInternalIp: 'IP Interno',
    colLastSeen: 'Ultima connessione',
    colMetrics: 'Metriche',
    colActions: 'Azioni',
    never: 'Mai',
    details: 'Dettagli',
    delete: 'Elimina',
    statTotal: 'Totale',
    statOnline: 'Online',
    statOffline: 'Offline',
    statBusy: 'Occupati',
    loadingAgent: 'Caricamento agente...',
    agentNotFound: 'Agente non trovato',
    backToAgents: 'Torna agli agenti',
    pingAgent: 'Ping',
    pinging: 'Ping...',
    systemCard: 'Sistema',
    networkCard: 'Rete',
    registeredCard: 'Registrato',
    tunnelActive: 'Tunnel attivo',
    polling: 'Polling',
    avg24h: 'media 24h',
    recentTasks: 'Attività recenti',
    noTasksExecuted: 'Nessuna attività eseguita'
  },

  // Equipment types
  equipmentTypes: {
    deleteConfirm: 'Sei sicuro di voler eliminare questa apparecchiatura?',
    launchAttack: 'Lancia attacco',
    validateDetection: 'Valida rilevamento',
    deleteEquipment: 'Elimina',
    deleted: 'Apparecchiatura eliminata',
    validationError: 'Errore durante la validazione',
    deleteError: 'Errore durante l\'eliminazione',
    categories: {
      server: 'Server',
      workstation: 'Workstation',
      network: 'Rete',
      security: 'Sicurezza',
      iot: 'IoT',
      ot_ics: 'OT/ICS',
      mobile: 'Mobile',
      cloud: 'Cloud',
      container: 'Container',
      database: 'Database',
      web_application: 'Applicazione Web',
      printer: 'Stampante',
      storage: 'Storage',
      voip: 'VoIP',
      other: 'Altro'
    }
  },

  // Sessions extra
  sessionsExtra: {
    sessionNotFound: 'Sessione non trovata',
    privescConfirm: 'Avviare un tentativo di escalation dei privilegi?',
    validateForReport: 'Valida per report',
    chainNames: {
      full_recon: 'Ricognizione Completa',
      cred_harvest: 'Raccolta Credenziali',
      pivot_recon: 'Scoperta Pivot',
      safe_migrate: 'Migrazione Sicura'
    },
    aptModules: 'Moduli APT (Minaccia Persistente Avanzata)',
    modulesAvailable: 'moduli disponibili'
  },

  // NetworkMap extra
  networkMap: {
    launchOwaspAnalysis: 'Servizi web - Avvia analisi OWASP',
    launchSimulation: 'Avvia Simulazione'
  },

  // ScanDetails extra
  scanDetails: {
    viewScanConfig: 'Visualizza configurazione scansione',
    downloadPdfReport: 'Scarica report PDF',
    pdfReport: 'Report PDF',
    relaunch: 'Riavvia',
    relaunchScan: 'Riavvia questa scansione con gli stessi parametri',
    schedule: 'Pianifica',
    scheduleScan: 'Pianifica questa scansione',
    refresh: 'Aggiorna',
    vpnConnectionRequired: 'Connessione VPN richiesta',
    vpnConnectionRequired2: 'Questa scansione richiede una connessione VPN per accedere alla rete interna',
    vpnConnectInstructions: 'Connettiti alla VPN configurata per questo spazio di lavoro e poi riavvia la scansione.',
    configureVpn: 'Configura VPN',
    viewWorkspaces: 'Visualizza spazi di lavoro',
    vpnConnection: 'Connessione VPN',
    scanServer: 'Server di scansione',
    vpnActive: 'VPN Attiva',
    directConnection: 'Connessione diretta',
    vpnServer: 'Server VPN',
    hostsDiscovered: 'Host scoperti',
    hostsDiscoveredDesc: 'Numero totale di macchine scoperte e accessibili nel perimetro scansionato.',
    totalVulnerabilities: 'Totale vulnerabilità',
    totalVulnerabilitiesDesc: 'Numero totale di falle di sicurezza (CVE) identificate su tutti gli host.',
    criticalVulnerabilities: 'Vulnerabilità critiche',
    criticalVulnerabilitiesDesc: 'CVSS 9.0-10.0: Falle che permettono una compromissione totale del sistema.',
    immediateActionRequired: 'Azione immediata richiesta.',
    scanConfiguration: 'Configurazione scansione',
    target: 'Obiettivo',
    scanType: 'Tipo di scansione',
    createdAt: 'Creato il',
    intensity: 'Intensità',
    queueHowItWorks: 'Come funziona la coda?',
    queueOrdered: 'Le scansioni vengono elaborate in ordine di arrivo con priorità secondo il piano',
    queueAutoUpdate: 'Questa pagina si aggiorna automaticamente',
    queueAutoStart: 'La scansione inizierà automaticamente quando saranno disponibili risorse',
    accelerateScans: 'Accelera le scansioni',
    accelerateDesc: 'Per ridurre i tempi di attesa e ottenere scansioni prioritarie:',
    proPlanOption: 'Piano Pro o Enterprise',
    proPlanDesc: 'Goditi una priorità maggiore nella coda e tempi di attesa ridotti',
    dedicatedServer: 'Server dedicato',
    dedicatedServerDesc: 'Scansioni istantanee senza coda - le tue risorse dedicate',
    viewPlans: 'Visualizza piani',
    noVulnDetected: 'Nessuna vulnerabilità rilevata',
    showTop5: 'Mostra le 5 più gravi',
    showAll: 'Mostra tutto',
    viewAll: 'Vedi tutto',
    viewDetails: 'Vedi dettagli',
    showingTop5: 'Visualizzazione delle 5 vulnerabilità {sortType} su {total} totali',
    bySeverity: 'più gravi',
    byDate: 'più recenti',
    capturedOn: 'Catturato il',
    imageLoadError: 'Errore nel caricamento dell\'immagine',
    autoGenerateReport: 'Genera automaticamente il report',
    selectReportFormats: 'Seleziona il/i formato/i di report da generare',
    reportFormats: 'Formati di report',
    reduceList: '← Riduci lista',
    showMoreHosts: 'Vedi gli altri {count} host →',
    stopScanConfirm: 'Sei sicuro di voler fermare questa scansione?',
    deleteScanConfirm: 'Sei sicuro di voler eliminare questa scansione?',
    retryScanConfirm: 'Riavviare questa scansione con gli stessi parametri?',
    stopScanFailed: 'Errore nell\'arresto della scansione',
    deleteScanFailed: 'Errore nell\'eliminazione della scansione',
    cleanupFailed: 'Errore di pulizia',
    immediatePatching: 'Patching immediato',
    immediatePatchingDesc: 'Applicare patch di sicurezza per le vulnerabilità critiche e alte identificate.',
    reduceAttackSurface: 'Riduzione della superficie di attacco',
    reduceAttackSurfaceDesc: 'Chiudere le porte non essenziali e limitare l\'esposizione dei servizi.',
    updateComponents: 'Aggiornamento dei componenti',
    updateComponentsDesc: 'Aggiornare il software vulnerabile alle ultime versioni sicure.',
    continuousMonitoring: 'Monitoraggio continuo',
    continuousMonitoringDesc: 'Implementare il monitoraggio dei log e degli alert per rilevare attività sospette.',
    noCriticalVulnsDetected: 'Nessuna vulnerabilità critica rilevata',
    majorityLowSeverity: 'Maggioranza di vulnerabilità a bassa gravità',
    fullCoverageMultipleTools: 'Copertura completa con molteplici strumenti di analisi',
    automatedScanFastDetection: 'Scansione automatizzata per rilevamento rapido',
    aiAssistedReport: 'Report generato con assistenza IA per analisi approfondita',
    implementSecurityRecommendations: 'Implementare le raccomandazioni di sicurezza',
    strengthenNetworkSegmentation: 'Rafforzare la segmentazione della rete',
    vulnManagementProgram: 'Programma di gestione delle vulnerabilità',
    regularSecurityAudits: 'Audit di sicurezza regolari',
    securityAwarenessTraining: 'Formazione sulla consapevolezza della sicurezza',
    hostsLabel: 'Host',
    vulnerabilitiesLabel: 'Vulnerabilità',
    criticalLabel: 'Critici',
    highLabel: 'Alti',
    mediumLabel: 'Medi',
    lowLabel: 'Bassi',
    highVulnsDesc: 'CVSS 7.0-8.9: Falle che possono portare ad accesso non autorizzato o perdita di dati.',
    mediumVulnsDesc: 'CVSS 4.0-6.9: Falle che richiedono condizioni specifiche per essere sfruttate.',
    lowVulnsDesc: 'CVSS 0.1-3.9: Falle a impatto limitato, da trattare nelle manutenzioni pianificate.'
  },

  // Subdomains
  subdomains: {
    title: 'Subdomain Discovery',
    description: 'Scopri i sottodomini e lancia attacchi automatizzati',
    searchTitle: 'Ricerca Sottodomini',
    domainPlaceholder: 'esempio.com',
    scanning: 'Scansione...',
    quickScan: 'Scansione rapida',
    fullScan: 'Scansione completa',
    toolsLabel: 'Strumenti della scansione completa',
    sessionExpired: 'Sessione scaduta. Effettua nuovamente il login.',
    discoveryError: 'Errore durante la scoperta dei sottodomini',
    networkError: 'Errore di rete. Controlla la connessione.',
    enterDomain: 'Inserisci un dominio',
    selectAtLeastOne: 'Seleziona almeno un sottodominio',
    subdomainsDiscovered: '{count} sottodomini scoperti',
    savedToWorkspace: ' — salvato nello spazio di lavoro',
    totalDiscovered: 'Totale scoperti',
    active: 'Attivi (risolvibili)',
    selected: 'Selezionati',
    duration: 'Durata',
    selectAllActive: 'Seleziona tutti gli attivi',
    deselectAll: 'Deseleziona tutto',
    scanSelected: 'Scansiona selezione ({count})',
    attacking: 'Attacco...',
    scansLaunched: '{count} scansione/i avviata/e sui sottodomini selezionati',
    discoveredSubdomains: 'Sottodomini scoperti',
    noAliveSubdomains: 'Nessun sottodominio attivo trovato',
    noAliveSubdomainsDesc: 'Questo dominio potrebbe non avere sottodomini pubblicamente indicizzati',
    resultsByTool: 'Risultati per strumento',
    emptyStateTitle: 'Subdomain Discovery',
    emptyStateDesc: 'Inserisci un dominio sopra per scoprire tutti i suoi sottodomini.',
    quickScanHint: 'per una ricerca rapida con Subfinder,',
    fullScanHint: 'per una ricerca approfondita.',
    configurableTools: 'Strumenti configurabili: Subfinder, Amass, DNSRecon, Risoluzione IP',
    dataFromWorkspace: 'Dati caricati dallo spazio di lavoro',
    rerunToRefresh: '— Riavvia una scansione per aggiornare',
    enrichedResultsSaved: 'Risultati arricchiti salvati nello spazio di lavoro',
    quickDiscoveryError: 'Errore durante la scoperta rapida'
  },

  // AI Agent
  aiAgent: {
    configTitle: 'Configurazione Agente',
    configSubtitle: 'Regola le soglie e i comportamenti dell\'agente IA',
    reset: 'Ripristina',
    save: 'Salva',
    generalSettings: 'Impostazioni generali',
    agentActive: 'Agente attivo',
    automaticMonitoring: 'Monitoraggio automatico',
    autoRecovery: 'Auto-ripristino',
    automaticRecovery: 'Ripristino automatico',
    dailyReport: 'Report giornaliero',
    summaryEmail: 'Email di riepilogo',
    alertThresholds: 'Soglie di alert',
    alert: 'Alert',
    critical: 'Critico',
    memory: 'Memoria',
    disk: 'Disco',
    intervals: 'Intervalli',
    monitoringSeconds: 'Monitoraggio (secondi)',
    aiAnalysisSeconds: 'Analisi IA (secondi)',
    healthCheckSeconds: 'Health Check (secondi)',
    scanSettings: 'Impostazioni scansione',
    scanTimeoutMin: 'Timeout scansione (minuti)',
    maxConcurrentScans: 'Scansioni simultanee max',
    errorRateThreshold: 'Soglia tasso errore (/h)',
    alerts: 'Alert',
    alertEmail: 'Email di alert',
    maxAlertsHour: 'Alert max/ora',
    deduplication: 'Deduplicazione (minuti)',
    aiModels: 'Modelli IA',
    primaryModel: 'Modello principale',
    strategicModel: 'Modello strategico',
    technicalModel: 'Modello tecnico',
    codeModel: 'Modello codice',
    dailyReportSettings: 'Report giornaliero',
    sendTime: 'Ora di invio',
    utcNote: '0-23 (ora UTC)',
    recipients: 'Destinatari (uno per riga)',
    conversationHistory: 'Cronologia conversazioni IA',
    noConversations: 'Nessuna conversazione',
    selectConversation: 'Seleziona una conversazione',
    configSaved: 'Configurazione salvata',
    configSaveError: 'Errore nel salvataggio della configurazione',
    configReset: 'Configurazione ripristinata',
    configResetError: 'Errore nel ripristino della configurazione',
    configResetConfirm: 'Ripristinare la configurazione predefinita?',
    deleteConversationConfirm: 'Eliminare questa conversazione?',
    conversationDeleted: 'Conversazione eliminata',
    conversationDeleteError: 'Errore nell\'eliminazione',
    loadMessagesError: 'Errore nel caricamento dei messaggi',
    untitledConversation: 'Conversazione senza titolo',
    modelsTitle: 'Modelli IA (Ollama)',
    modelsSubtitle: 'Stato dei modelli LLM usati dall\'agente',
    ollamaOnline: 'Online',
    ollamaStopped: 'Fermato',
    ollamaError: 'Errore',
    vramAvailable: 'Memoria disponibile per i modelli',
    defaultModel: 'Modello predefinito',
    availableModels: 'Modelli disponibili',
    loaded: 'Caricato',
    available: 'Disponibile',
    notAvailable: 'Non disponibile',
    noModelsDetected: 'Nessun modello rilevato',
    usageStats: 'Statistiche di utilizzo ({period})',
    totalRequests: 'Richieste totali',
    tokensUsed: 'Token utilizzati',
    requestsByModel: 'Richieste per modello',
    avgLatency: 'Latenza media (ms)',
    testModel: 'Testa',
    modelError: 'Errore: {error}',
    testError: 'Errore durante il test',
    loadModelsError: 'Errore nel caricamento dei modelli',
    actionsTitle: 'Cronologia Azioni',
    actionsSubtitle: 'Azioni eseguite dall\'agente IA',
    totalActions: 'Azioni totali',
    successful: 'Riuscite',
    failed: 'Fallite',
    successRate: 'Tasso di successo',
    actionsByType: 'Azioni per tipo',
    noActionsRecorded: 'Nessuna azione registrata',
    filterType: 'Tipo',
    filterCategory: 'Categoria',
    filterResult: 'Risultato',
    all: 'Tutti',
    allCategories: 'Tutte',
    succeeded: 'Riuscito',
    loadActionsError: 'Errore nel caricamento delle azioni',
    metricsTitle: 'Metriche di sistema',
    noData: 'Nessun dato',
    loadMetricsError: 'Errore nel caricamento delle metriche',
    incidentsTitle: 'Incidenti',
    incidentsSubtitle: 'Incidenti rilevati dall\'agente IA',
    acknowledge: 'Accetta',
    resolve: 'Risolvi',
    retryRecovery: 'Riavvia il ripristino',
    incidentAcknowledged: 'Incidente accettato',
    incidentResolved: 'Incidente risolto',
    recoveryRelaunched: 'Ripristino riavviato',
    loadIncidentsError: 'Errore nel caricamento degli incidenti',
    noIncidents: 'Nessun incidente',
    filterSeverity: 'Gravità',
    filterStatus: 'Stato',
    allSeverities: 'Tutte',
    allStatuses: 'Tutti'
  },

  // Orchestrator
  orchestrator: {
    title: 'Orchestratore IA',
    subtitle: 'Motore intelligente di sfruttamento e analisi autonoma',
    active: 'ATTIVO',
    inactive: 'INATTIVO',
    disable: 'Disabilita',
    enable: 'Abilita (Modalità Sicura)',
    enableSafe: 'Abilita',
    retry: 'Riprova',
    connectionError: 'Errore di connessione all\'orchestratore',
    serviceUnavailable: 'Servizio temporaneamente non disponibile. Per favore riprova.',
    stateChangeError: 'Errore nel cambio di stato dell\'orchestratore',
    activeScans: 'Scansioni attive',
    aiDecisions: 'Decisioni IA',
    aiModels: 'Modelli IA',
    minConfidence: 'Confidenza min.',
    loadedModels: 'Modelli IA caricati',
    loadingModels: 'Caricamento modelli Ollama...',
    exploitationMode: 'Modalità di sfruttamento',
    confidenceThreshold: 'Soglia di confidenza',
    minConfidenceNote: 'Livello minimo di confidenza per azioni automatiche',
    safeModeNote: 'La modalità Sicura evita exploit distruttivi',
    recentDecisions: 'Decisioni IA recenti',
    noAiActivity: 'Nessuna attività IA',
    decisionsAppearHere: 'Le analisi e decisioni IA appariranno qui',
    configuration: 'Configurazione'
  },

  // License
  license: {
    expiredBadge: 'LICENZA SCADUTA',
    revokedBadge: 'LICENZA REVOCATA',
    cancelledBadge: 'LICENZA ANNULLATA',
    noLicenseBadge: 'NESSUNA LICENZA',
    expiredTitle: 'La tua licenza è scaduta',
    expiredSubtitle: 'L\'accesso alla piattaforma è sospeso in attesa del rinnovo.',
    revokedTitle: 'La tua licenza è stata revocata',
    revokedSubtitle: 'L\'accesso alla piattaforma è stato sospeso da SYLink Security.',
    cancelledTitle: 'La tua licenza è stata annullata',
    cancelledSubtitle: 'Il tuo abbonamento è stato annullato. I tuoi dati vengono conservati per 30 giorni.',
    noLicenseTitle: 'Nessuna licenza attiva',
    noLicenseSubtitle: 'Attiva una licenza per accedere alla piattaforma SYLink Pentest.',
    renewAction: 'Rinnova la mia licenza',
    accessSettings: 'Accedi alle impostazioni',
    contactSyLink: 'Contatta SYLink',
    subscribeAction: 'Abbonati a un nuovo piano',
    exportData: 'Esporta i miei dati',
    activateLicense: 'Attiva la mia licenza',
    licenseInfo: 'Informazioni licenza',
    reference: 'Riferimento',
    tier: 'Livello',
    expiredOn: 'Scaduto il',
    holder: 'Titolare',
    expiry: 'Scadenza',
    plan: 'Piano',
    loggedAs: 'Connesso come',
    adminBypass: 'Amministratore - Reindirizzamento al pannello...',
    contactSupport: 'Contatta il supporto',
    warningExpired: 'I tuoi dati sono preservati. Rinnova la licenza per ripristinare l\'accesso completo.',
    warningExpiredEmail: 'È stata inviata un\'email di promemoria a',
    warningRevoked: 'L\'accesso è stato revocato per decisione amministrativa.',
    warningCancelled: 'Il tuo abbonamento è stato annullato. Hai 30 giorni per esportare i tuoi dati.',
    warningNoLicense: 'Accedi alle impostazioni del tuo account per inserire la chiave di licenza.',
    needHelp: 'Hai bisogno di aiuto?'
  },

  // Accept Invitation
  acceptInvitation: {
    verifying: 'Verifica dell\'invito...',
    alreadyActivatedTitle: 'Account già attivato',
    alreadyActivatedDesc: 'Il tuo account è stato attivato con successo. Puoi ora effettuare il login.',
    login: 'Accedi',
    invitationExpiredTitle: 'Invito scaduto',
    invitationInvalidTitle: 'Invito non valido',
    expiredHint: 'Gli inviti sono validi 7 giorni. Chiedi al tuo amministratore di inviarne uno nuovo.',
    invalidHint: 'Se hai ricevuto più email di invito, usa il link dell\'ultima.',
    contactSupport: 'Contatta il supporto',
    welcomeTitle: 'Benvenuto nel team!',
    accountActivated: 'Il tuo account è stato attivato con successo.',
    redirecting: 'Reindirizzamento al pannello...',
    joinTeamTitle: 'Invito a unirsi al team',
    missingToken: 'Token di invito mancante',
    acceptError: 'Errore nell\'accettazione dell\'invito',
    genericError: 'Si è verificato un errore'
  },

  // Dedicated Server page
  dedicatedServer: {
    pageTitle: 'Server Dedicato - Infrastruttura Sovrana',
    heroTag: 'Soluzione sovrana 100% italiana',
    heroTitle: 'Infrastruttura',
    heroTitleHighlight: 'Dedicata',
    heroDesc: 'Una soluzione di pentest isolata, gestita e supervisionata per la tua azienda. Ospitata in Francia, senza i vincoli delle soluzioni straniere.',
    statFrench: 'Francese',
    statQueue: 'Coda d\'attesa',
    statSupervision: 'Supervisione',
    statAvailability: 'Disponibilità',
    whyDedicated: 'Perché scegliere l\'infrastruttura dedicata?',
    whyDedicatedDesc: 'Beneficia di una soluzione su misura adattata alle tue esigenze di sicurezza e prestazioni',
    hostingOptions: 'Opzioni di hosting',
    hostingOptionsDesc: 'Scegli l\'hosting più adatto alle tue esigenze: nel nostro datacenter sovrano o direttamente nella tua infrastruttura',
    recommended: 'Raccomandato',
    aiTitle: 'SYLink IA - Modelli di cybersicurezza specializzati',
    aiDesc: 'Distribuisci la nostra IA cybersicurezza specializzata direttamente sulla tua infrastruttura. Analisi locale, senza invio di dati all\'esterno.',
    parameters: 'parametri',
    poweredBy: 'Sviluppato da Ollama',
    localLLM: 'Esecuzione locale di modelli LLM',
    viewOnOllama: 'Visualizza su Ollama',
    ctaTitle: 'Pronto a passare all\'infrastruttura dedicata?',
    ctaDesc: 'Contatta il nostro team commerciale per una valutazione personalizzata delle tue esigenze e un preventivo su misura.',
    requestQuote: 'Richiedi un preventivo',
    viewAllPlans: 'Vedi tutti i piani',
    trustFrenchTech: 'Tecnologia francese',
    trustFrenchTechDesc: 'Sviluppato in Francia, senza dipendenze da tecnologie straniere',
    trustGDPR: 'Conformità GDPR',
    trustGDPRDesc: 'Hosting sovrano conforme alle normative europee',
    trustProtectedData: 'Dati protetti',
    trustProtectedDataDesc: 'I tuoi dati rimangono in Francia, protetti dal Cloud Act e dal FISA',
    adv1Title: 'Isolamento Totale',
    adv1Desc: 'Infrastruttura dedicata e isolata per la massima sicurezza. Nessuna condivisione di risorse con altri clienti.',
    adv2Title: 'Prestazioni Garantite',
    adv2Desc: 'Risorse CPU, RAM e storage dedicati. Scansioni istantanee senza code né limitazioni.',
    adv3Title: 'Sovranità dei Dati',
    adv3Desc: 'Hosting 100% francese, senza i vincoli delle soluzioni straniere (Cloud Act, FISA).',
    adv4Title: 'Supervisione 24/7',
    adv4Desc: 'Monitoraggio continuo, avvisi in tempo reale e intervento proattivo dei nostri team.',
    adv5Title: 'Supporto Dedicato',
    adv5Desc: 'Team tecnico dedicato, SLA garantito e accompagnamento personalizzato.',
    adv6Title: 'Disponibilità 99,9%',
    adv6Desc: 'Infrastruttura ridondante con alta disponibilità e piano di ripristino delle attività.',
    hostingDatacenterTitle: 'France Data Center - Reims',
    hostingDatacenterLoc: 'Reims, Francia',
    hostingOnPremTitle: 'On-site',
    hostingOnPremLoc: 'La tua infrastruttura',
    ai8bDesc: 'Modello leggero e veloce per le analisi standard',
    ai8bSpecs: 'GPU: 8 GB VRAM minimo',
    ai8bUseCase: 'Analisi rapide, report automatizzati',
    ai30bDesc: 'Modello bilanciato per le analisi approfondite',
    ai30bSpecs: 'GPU: 24 GB VRAM minimo',
    ai30bUseCase: 'Analisi dettagliate, correlazioni avanzate',
    ai80bDesc: 'Modello esperto per le analisi complesse',
    ai80bSpecs: 'GPU: 80 GB VRAM minimo',
    ai80bUseCase: 'Analisi esperte, ricerca di vulnerabilità'
  },

  // Account Reports Config page
  accountReports: {
    configSaved: 'Configurazione salvata',
    configSaveError: 'Errore durante il salvataggio della configurazione',
    clientAdded: 'Cliente aggiunto',
    clientAddError: 'Errore durante l\'aggiunta',
    clientDeleted: 'Cliente eliminato',
    clientDeleteError: 'Errore durante l\'eliminazione',
    loadError: 'Errore durante il caricamento',
    deleteClientConfirm: 'Eliminare questo cliente?',
    unsavedChanges: 'Hai modifiche non salvate',
    save: 'Salva',
    saving: 'Salvataggio...',
    clientsTitle: 'Clienti',
    addClient: 'Aggiungi',
    clientName: 'Nome cliente *',
    sirenOptional: 'SIREN (opzionale)',
    noClientsConfigured: 'Nessun cliente configurato',
    reportTypesTitle: 'Tipi di Report',
    reportTypesDesc: 'Personalizza i tipi di report disponibili per la tua organizzazione',
    customName: 'Nome personalizzato',
    customDescription: 'Descrizione personalizzata',
    infoNote: 'Queste impostazioni sono specifiche della tua organizzazione. Le modifiche riguardano solo i tuoi report.'
  }

};
